// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/lato);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  font-family: 'Lato', sans-serif !important;
}

.center {
  margin: auto;
  width: 50%;
  /* border: 3px solid green; */
  padding: 10px;
}

.main_container {
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
  font-family: 'Lato', sans-serif !important;
}

.container_box {
  max-width: 1240px;
  height: auto;
  margin: 0 auto;
  padding: 0;
  height: 100%;
  min-height: 100vh;
}

.container_box form[name="signup"] {
  padding-top: 24px;
}

.header {
  margin-top: 30px;
  text-align: center;
}

.header img {
  max-width: 180px;
  margin-bottom: -20px;
}

.container_box .login_box,.container_box .signup_box  {
  max-width: 280px;
  /* min-height: 245px; */
  border-radius: 30px;
  background: #283c89;
  margin: 20px auto 40px;
  padding: 30px 30px 10px 30px;
}

.login_box .input_box {
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.input_box i {
  color: #fff;
}

.input_box label {
  background: #00115e;
  padding: 13px;
  width: 15%;
  text-align: center;
}

.input_box input {
  border: 1px solid #eee;
  padding: 0px 15px;
  width: 75%;
  outline: none;
  height: 45px;
}

.input_box input.button_styl,
.input_box button.button_styl {
  background: #00115e;
  color: #fff;
  margin-top: 10px;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
  border: none;
  text-align: center;
  padding: 12px;
}

.input_box button.red_button_styl {
  background: red;
  color: #fff;
  margin-top: 10px;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
  border: none;
  text-align: center;
  padding: 15px;
}

.input_box a {
  color: #fff;
  font-size: 12px;
  text-decoration: none;
  /* font-weight: 600; */
}

.input_box.cancel_btn a {
  color: #000;
  font-size: 13px;
  text-decoration: none;
  font-weight: 600;
}

.input_box a:hover {
  text-decoration: underline;
}

.footer_box {
  background: #283c89;
  padding: 10px 20px 20px 20px;
  position: relative;
  bottom: 0;
  border-radius: 2px;
  width: 96%;
  margin: 0px auto 0;
}

.notify {
  background: #fff;
  padding: 4px 20px;
  margin: 0;
  border-bottom: 2px solid #283c89;
  max-width: 100%;
}

hr {
  margin-top: 15px;
  margin-bottom: 15px;
  border: 1px solid #dfdede;
}


.notify p {
  font-size: 14px;
  color: #005fb2;
  margin: 0;
  padding: 5px 0px;
}

.notify p a {
  font-size: 1em;
  color: #005fb2;
  font-style: italic;
  cursor: pointer;
}

.notify p a:hover {
  color: #005fb2 !important;
  text-decoration: underline;
}

.notify p i {
  font-size: 14px;
  color: #00A1E0;
  padding: 0px 10px 0px 0px;
}

/* .container_box .signup_box {
  max-width: 280px;
  min-height: 280px;
  border-radius: 30px;
  background: #283c89;
  margin: 20px auto;
  padding: 20px 25px 5px 25px;
} */

.signup_box .input_box {
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.input_box i {
  color: #fff;
}

.signup_box .input_box label {
  background: transparent;
  padding: 5px 0px;
  width: 100%;
  text-align: left;
  color: #fff;
  font-size: 14px;
}

.signup_box input {
  border: 1px solid #eee;
  padding: 18px;
  width: 65%;
  outline: none;
}

.signup_box .input_box p {
  text-align: center;
  width: 100%;
  color: #fff;
  font-size: 14px;
}

.signup_box input {
  border: 1px solid #eee;
  padding: 0px 10px;
  width: 93%;
  outline: none;
  height: 40px;
}

.form_styl input.error_msg,
.form_styl div.error_msg,
.form_styl textarea.error_msg,
.form_styl1 .inner_part select.error_msg,
.form_styl table td select.error_msg,
.form_styl .inner_part select.error_msg,
.form_styl .inner_part1 select.error_msg {
  outline: red;
  border: 1.5px solid red;
  margin-bottom: 0px;
  border-radius: 4px;
}

.signup_box input.button_styl {
  background: #00115e;
  color: #fff;
  margin-top: 20px;
  font-size: 16px;
  cursor: pointer;
  width: 92%;
  border: none;
  text-align: center;
}

.signup_box .input_box label span {
  color: #EA001c;
  font-size: 14px;
}

.main_header {
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
  background: linear-gradient(to right, #2b308b, #2572a3);
}

.top_header {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.logostyl img {
  max-width: 120px;
  padding: 3px 0px 0px 0px;
}
input:-webkit-autofill {
  background-color: transparent !important;
}
.user_profile {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 7px 0px;
}

.profile_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 5px 25px;
}

.profile_box span {
  background: #fff;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
}

.profile_box span i {
  font-size: 18px;
  padding: 8px 10px;
  color: #2669a0;
}

.profile_box h4 {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin: 0;
  cursor: pointer;
  padding-left: 5px;
}

.search_box {
  background: #fff;
  height: 20px;
  padding: 3px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-radius: 5px;
}

.search_box input {
  width: 100%;
  border: none;
  outline: none;
}

.search_box i {
  font-size: 12px;
  padding: 0px 5px;
}

.main_menu {
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
  background: #000f59;
}

.menu_header {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 0px 10px;
}

.nav_link {
  width: 35%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0px;
}

.nav_link ul li,
.nav_link ul li a {
  display: inline-block;
  color: #fff;
  padding: 0px 20px 0px 0px;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
}

.nav_link ul {
  margin: 0;
  padding: 8px 0px;
}

.main_part {
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
  font-family: 'Lato', sans-serif;
}

.redirect_container {
  background-image: url(https://apf-uat--uat.sandbox.my.site.com/admissions/file-asset/univ_building_8_reduced_image?v=1);
  width: 100%;
  min-height: 600px;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 10px 0px;
  min-height: 97vh;
}

.container_body {
  max-width: 1200px;
  width: 100%;
  height: auto;
  margin: 0 auto;
  padding: 30px 0px;
}

.container_body p {
  font-size: 14px;
  margin: 0;
  padding: 0px 15px;
  line-height: 22px;
}

.w30 .form_styl1 .distance_learn p {
  text-decoration: none;
  padding: 10px 0px;
  line-height: 1.3;
  cursor: pointer;
  border-bottom: 1.5px solid #727272;
  color: #294799;
  font-size: 15px;
  font-weight: 600;
}

.w30 .form_styl1 .distance_learn p:hover {
  text-decoration: underline;
}

.w30 .form_styl1 .topic_art p {
  text-decoration: underline;
  padding: 5px 0px;
  line-height: 1.3;
  cursor: pointer;
  font-size: 13px;
}

.w33 .form_styl1 .topic_art p:hover {
  text-decoration: underline;
}

.w33 .form_styl1 .topic_art p i {
  margin-left: 3px;
}

.sub_topic {
  padding: 5px 15px 15px;
}

.w33 .form_styl1 .topic_art .sub_topic p {
  padding: 3px;
}

.home_app .form_styl1 .w100 p {
  padding: 20px 0px 0px 0px;
}

.container_body .notes h4 {
  font-size: 20px;
  margin: 0;
  padding: 0px 15px;
  line-height: 26px;
  font-weight: 600;
}

.container_body .redirectnotes h4 {
  font-size: 20px;
  margin: 0;
  padding: 0px;
  line-height: 2;
  font-weight: 600;
}

.container_body .redirectnotes h4 {
  font-size: 21px;
  margin: 0;
  padding: 0px;
  line-height: 26px;
  font-weight: 600;
}

.container_body .redirectnotes p,
.signinredrct .redirectnotes a {
  color: #294799;
  font-weight: 700;
  font-size: 14px;
  padding: 0;
  margin: 0 auto;
}

.signinredrct .redirectnotes a.cButton {
  color: #fff;
  padding: 3px;
}


.container_body .form_sec p {
  padding: 0px;
  font-size: 15px;
}

.container_body .notes p,
.container_body .notes p a {
  color: #294799;
  font-weight: 700;
  font-size: 15px;
}

.pb1 {
  padding-bottom: 10px !important;
}

.container_body .notes span ol {
  color: #294799;
  display: block;
  list-style-type: decimal;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
  unicode-bidi: isolate;
  font-weight: 700;
  font-size: 15px;
}

.container_body .notes span ol li {
  color: #294799;
  display: list-item;
  text-align: -webkit-match-parent;
  unicode-bidi: isolate;
  font-weight: 700;
  font-size: 15px;
}

.heading_styl {
  background: linear-gradient(to right, #2b308b, #2572a3);
  border-radius: 5px;
}

.right_panel .form_styl .heading_styl h4,
.right_panel .heading_styl h4,
.form_styl .form_sec_inner .heading_styl h4,
.heading_styl h4 {
  font-size: 15px;
  font-weight: 400;
  color: #fff;
  padding: 10px;
  margin-bottom: 10px;
  margin-top: 20px;
  /* text-transform: uppercase; */
}

.form_part .form_styl .inner_part1 .heading_styl h4 {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  padding: 5px;
  letter-spacing: 1px;
  margin-top: 0px;
  margin-bottom: 0px;
  border: 1px solid #ccc;
}

.form_part span.redstyl,
p.redstyl,
span.redstyl,
.form_styl span.redstyl,
.sidebar p.redstyl {
  font-size: 13px;
  color: red !important;
  cursor: pointer;
  font-weight: 600;
  text-align: left;
}

.container_body .form_styl p {
  font-size: 13px;
  color: #294799;
  cursor: auto;
  font-weight: 600;
  padding: 0px;
  text-align: left;
  line-height: 1.3;
}

.container_body .reg_complete p {
  font-size: 13px;
  padding-bottom: 15px;
  line-height: 1.3;
}

.form_sec {
  padding: 30px 40px 30px 40px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-top: 10px;
}

.form_sec_inner {
  padding: 0px 10px 10px 10px;
  border: 1px solid #3f3f3f;
  border-radius: 20px;
  margin: 5px 10px;
  width: calc(50% - 40px) !important;
  min-height: 540px;
}

.inner_part {
  display: flex;
  flex-direction: column;
  width: 49%;
}

.actionrequired {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 14px;
}

.actionrequired a {
  font-size: 14px;
  padding: 0px 2px;
  color: #294799;
}

.actionred h4 {
  color: red;
}

.actionred p {
  padding: 10px 0px;
}

form .form_sec .form_styl .inner_part {
  font-size: 13px !important;
  color: #294799 !important;
  line-height: 20px;
  font-weight: 600;
}

.inner_part1 {
  display: flex;
  flex-direction: column;
  width: 24%;
  border: 2px solid #ccc;
  padding: 0px;
}

.inner_part2 {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.b_none {
  border: none;
  padding: 0px;
}

.mt-7 {
  margin: 7px !important;
}

.inner_part label,
.inner_part1 label,
.inner_part2 label {
  font-size: 13px;
  padding-bottom: 5px;
  font-weight: 600;
  color: black;
  display: flex;
}

.inner_part select {
  padding: 7px;
  border: 1px solid #bbbbbb;
  border-radius: 4px;
  margin: 0px;
}

.inner_part1 select,
.inner_part2 select {
  padding: 7px;
  border: 1px solid #bbbbbb;
  border-radius: 4px;
  margin: 0px;
}

.inner_part input,
.inner_part1 input,
.inner_part2 input {
  padding: 7px;
  border: 1px solid #bbbbbb;
  border-radius: 4px;
  margin-bottom: 10px;
}

.form_styl .inner_part input[type="radio"] {
  padding: 0px;
  margin: 2px;
  justify-content: center;
  display: flex;
  align-items: baseline;
}

.inner_part label,
.inner_part1 label,
.inner_part2 label {
  padding-top: 10px;
}

.form_styl .inner_part span.flex:hover {
  text-decoration: none;
}

.form_styl {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
}

.form_styl.faqlist {
  padding: 30px 0px 0px 0px;
}

.form_styl1 {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: self-start;
  margin-top: 0px;
}

.w100 {
  width: 100% !important;
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
}

label.f_size {
  font-size: 12px;
  padding-left: 3px;
}

.banner_styl {
  width: 100%;
  height: auto;
}

.banner_styl img {
  max-width: 100%;
}

.home_sec {
  padding: 10px 20px 20px 20px;
  border: 1px solid #d4d4d4;
  border-radius: 10px;
  margin-top: 0px;
  width: 66% !important;
}

.home_app {
  padding: 10px 0px 20px 0px;
  border-radius: 10px;
  margin-top: 3px;
  width: 70% !important;
}

.form_styl h4 {
  font-size: 18px;
  margin: 0;
  padding: 10px 0px;
  color: #3e3e3e;
  font-weight: normal;
}

.form_styl h4 span {
  color: red;
}

.form_styl a,
p.top_head_styl,
.form_sec .form_styl .inner_part p,
.form_styl span {
  font-size: 13px !important;
  color: #294799 !important;
  line-height: 20px;
  cursor: auto;
  font-weight: 600;
  text-decoration: none;
  padding: 0;
}

.form_sec .form_styl .inner_part span p {
  cursor: pointer;
}

.form_styl span.react-date-picker__inputGroup__leadingZero {
  display: inline-block;
  font: inherit;
  color: black !important;
  line-height: 0;
  font-size: 13px !important;
  font-weight: normal;
}

.react-date-picker--disabled span.react-date-picker__inputGroup__leadingZero {
  color: #a1a1a1 !important;
}

.react-date-picker__button svg {
  width: 16px;
}

.form_styl a:hover,
.form_styl span:hover {
  text-decoration: none;
}
.form_styl a.linkcheckegi:hover{
text-decoration: underline;
cursor: pointer;
}

.home_app table tr th,
.home_app table tr td {
  text-align: left;
  border-bottom: 1px solid #979696;
  padding: 10px 0px;
  font-size: 14px;
  color: #4c4c4c;
}

.home_app table tr td a {
  color: rgb(0 94 175);
}

.form_styl1 h4 {
  margin: 0px 0px 5px 0px !important;
  font-weight: 600;
  line-height: 24px;
  font-size: 18px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 10px;
}

button.submit.btnClassSubmit {
  margin: 0 15px;
  background-color: #27409a;
}

button.submit.btnClassSubmit:hover {
  background: #27409a;
}

input.submit,
button.submit {
  background: #d52a10;
  color: #fff;
  width: auto;
  margin: 0 auto;
  margin-top: 20px;
  outline: none;
  font-size: 13px;
  font-weight: 400;
  padding: 7px 15px;
  border: none;
  cursor: pointer;
  border-radius: 4px;
}

input.faq_submit {
  background: #d52a10;
  color: #fff;
  width: 10%;
  margin-top: 20px;
  outline: none;
  font-size: 13px;
  font-weight: 400;
  padding: 7px;
  border: none;
  cursor: pointer;
  border-radius: 4px;
}

input:disabled,
button.disabled,
.disabled,
.inner_part select:disabled,
.inner_part2 select:disabled {
  background: #eee;
  border: 1px solid #ccc;
  color: #a1a1a1;
  cursor: no-drop;
}

.inner_part select:disabled.react-date-picker__inputGroup__input {
  border: none;
}

input.submit:hover,
button.submit:hover {
  background: #a6210c;
}

.ml_5 {
  margin-left: 5px !important;
}

.sidebar {
  height: 400px;
  width: 21%;
  margin-left: 0px;
  padding-top: 20px;
  background: #fff;
  border-right: 2px solid #ccc;
}

.sidebar h4 {
  font-size: 12px;
  font-weight: normal;
  padding: 3px 0px;
  margin: 0;
  text-align: center;
}

.sidebar ul {
  margin: 0;
  padding: 10px 0px;
}

.sidebar ul li {
  font-size: 15px;
  display: block;
  line-height: 36px;
  font-weight: normal;
  padding: 8px 20px;
}

.sidebar ul li a {
  font-size: 13px;
  display: flex;
  line-height: 21px;
  font-weight: normal;
  padding: 3px 5px;
  text-decoration: none;
  color: #000;
  opacity: 0.8;
  align-items: center;
}

.sidebar ul li.active {
  background: #e7f3fd;
  padding: 8px 18px;
  border-left: 4px solid #d51e10;
}

.sidebar ul li.active a {
  font-weight: 600;
}

.sidebar ul li:hover {
  background: #e7f3fd;
  border-left: 2px solid #d51e10;
  padding: 8px 18px;
  cursor: pointer;
}

.sidebar ul li i {
  background: #008000;
  padding: 7px;
  border-radius: 50%;
  color: #fff;
  margin-right: 5px;
  font-size: 12px;
}

.sidebar ul li span.pink i {
  background: #fe617c;
  padding: 7px;
  border-radius: 50%;
  color: #fff;
  margin-right: 5px;
  font-size: 12px;
}

.progressbar {
  width: 90%;
  background-color: #ddd;
  border-radius: 10px;
  margin: 5px 10px 0px 10px;
}

.scorebar {
  text-align: right;
  padding-top: 10px;
  padding-bottom: 10px;
  color: white;
}

.sidebar .progress_clr {
  width: 20% !important;
  background-color: #04AA6D;
  border-radius: 10px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: .75rem;
  font-size: 14px;
}

.right_panel {
  padding: 10px 15px;
  width: 79%;
}

.right_panel .scroll_styl {
  max-height: 500px;
  overflow-Y: scroll;
  padding-right: 15px;
  overflow-X: hidden;
}

.right_panel h4.panelhead {
  font-size: 1.25rem;
  margin: 0;
  padding: 10px 0px;
  color: #3e3e3e;
}

.form_sec .form_styl p {
  font-size: 13px;
  text-align: justify;
  padding: 0px 0px 0px 0px;
  color: #294799;
  line-height: 20px;
  padding-top: 10px;
  font-weight: 700;
  cursor: auto;
}

.form_sec .form_styl p a {
  cursor: pointer;
}

.form_sec .form_styl .blctext {
  margin-bottom: 25px;
}

.form_sec .form_styl .blctext p {
  font-size: 15px;
  text-align: left;
  padding: 0px 0px 0px 0px;
  line-height: 1;
  padding-top: 10px;
  font-weight: 400;
  color: #333333;
}

.footer_box h4 {
  color: #fff;
  display: block;
  padding: 6px 0px;
  margin: 0;
  font-size: 16px;
}

.footer_box h4 img {
  max-width: 18px;
  vertical-align: bottom;
}

span.earlyadmin p,
span.regularadmin p,
span.postearlyadmin p {
  font-size: 13px !important;
  color: red;
  line-height: 1.3;
  cursor: auto;
  padding: 10px 0px;
  display: inline;
}

span.earlyadmin,
span.regularadmin,
span.postearlyadmin {
  top: 7px;
  position: relative;
}

span.earlyadmin a,
span.regularadmin a,
span.postearlyadmin a {
  color: rgb(0, 17, 94);
  font-weight: 400;
  font-size: 1p3x;
}

span.earlyadmin p a,
span.regularadmin p a,
span.postearlyadmin p a {
  color: #032d60;
}

.mt-3 {
  margin-top: 30px;
}

span.prvw {
  padding: 10px 0px;
  line-height: 3;
}

#programTool,
#fedu,
#medu,
#orghelpTooltip,
#exphelpTooltip,
#famocc,
#dob,
#helpTooltip,
#stateTooltip,
#yearTooltip,
#regionhelpTooltip,
#class12helpTooltip,
#areaTooltip,
#domicileTooltip,
#progPreference,
#yearcompletion,
#yearcompletionEdu,
#typeoforg,
#expoforg,
#relevantwork,
#programTooltip,
#famin {
  width: 235px;
  background: #032d60;
  cursor: pointer;
  margin-left: 0px;
  color: #fff !important;
  padding: 5px;
  opacity: 1;
}

.help_link #helpTooltip,
#educationhelp {
  width: 170px;
  background: #032d60;
  cursor: pointer;
  margin-left: 0px;
  color: #fff !important;
  padding: 5px;
  opacity: 1;
}


#programTool p,
#famin p,
#areaTooltip p,
#dob p,
#fedu p,
#medu p,
#domicileTooltip p,
#famocc p,
#helpTooltip p,
#yearTooltip p,
#regionhelpTooltip p,
#stateTooltip p,
#class12helpTooltip p,
#orghelpTooltip p,
#yearcompletion p,
#yearcompletionEdu p,
#progPreference p,
#typeoforg p,
#expoforg p,
#relevantwork p,
#exphelpTooltip p {
  color: #fff !important;
  font-size: 12px !important;
  padding-top: 0px;
  text-align: left;
  font-weight: normal;
  line-height: 1.3;
}


.inner_part label i,
.form_styl table tr td i,
.form_styl table tr th i,
.right_panel span.help_link i {
  cursor: pointer;
  color: #747474;
  margin: 3px;
}
.form_styl table tr td i{
  color: #000;
  margin: 3px;
  cursor: auto !important;
}
.form_styl table th i{
  color: #fff !important;
}
.inner_part label i:hover,
.form_styl table tr td i:hover,
.right_panel span.help_link i:hover {
  cursor: pointer;
  color: #a6170c;
}

span.clender_styl i {
  top: 0px;
  position: absolute;
  color: #032d60;
  font-size: 16px;
  padding: 7px 0px;
  display: flex;
  justify-content: flex-end;
  right: 10px;
  cursor: pointer;
}

.clender_styl span.w100 {
  padding: 0;
  margin: 0;
  position: relative;
}

.dflex {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

span.help_link {
  display: flex;
  justify-content: flex-end;
}

span.help_link p a {
  color: #032d60;
  text-decoration: none;
  font-size: 14px;
}

span.help_link p a:hover {
  text-decoration: underline;
}

span.help_link p a i {
  color: #a6170c;
}

.blc_txt {
  margin-bottom: 15px;
}

.container_body .form_styl .blc_txt p {
  color: #000 !important;
  font-weight: 600;
  line-height: 12px;
}

.blc_txt p i {
  color: #000;
  font-weight: normal;
}

.right_panel .dflex h4.top_head,
.right_panel .dflex h4,
.right_panel .w100 h4.top_head {
  color: #00f;
  font-size: 18px;
}

.form_styl table th {
  border: 1px solid #ccc;
  margin: 0;
  background: linear-gradient(to right, #2b308b, #2572a3);
  border-radius: 5px;
  width: 33%;
  padding: 12px 10px;
  color: #fff;
}

.form_styl table td {
  border: 1px solid #ccc;
  margin: 0;
  width: 33.33%;
  padding: 15px 10px;
  font-size: 14px;
  font-weight: 600;
}
.form_styl table td.previewPhotoupload{
  width: 20%;
}

.form_styl table {
  width: 100%;
  border: 1px solid #ccc;
  border-collapse: collapse;
}

.form_styl table td input {
  width: 96%;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 2px;
  height: 25px;
}

.form_styl table td select {
  width: 96%;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 2px;
  height: 32px;
}
.ug_eduform .form_styl table td select,.ug_eduform .form_styl table td input{
  width: 100%;
  box-sizing: border-box;
  height: 30px;
}

.form_styl table td.bottom_clr {
  padding: 5px 10px;
}

.form_styl table td.bottom_clr:hover,
.form_styl table tr:hover {
  background: transparent;
}

.d_none {
  display: none;
}

.login_box p,
.error_shown {
  color: red;
  font-size: 13px;
  line-height: 1.3;
  font-weight: normal;
}

.w33 {
  width: 33%;
  padding: 0px 15px;
}

.w40 {
  width: 40%;
  padding: 0px 15px;
}

.w30 {
  width: 30%;
  padding: 0px 15px;
}

.w66 {
  width: 66%;
  padding: 0px 15px;
}

.uploadfile a {
  padding: 7px 0px;
  color: #294799;
  font-size: 15px;
  text-decoration: none;
}

.uploadfile a i {
  margin-right: 5px;
}

table {
  font-size: 14px;
}

.form_styl1 table tr th,
.form_styl1 table tr td {
  text-align: left;
  border-bottom: 1px solid #979696;
  padding: 10px 6px;
  font-size: 14px;
  color: #4c4c4c;
  width: 19%;
  word-wrap: break-word;
  max-width: 150px;
}

.container_body .faq .form_styl .raisequerydesc p {
  font-size: 13px;
  color: #a1a1a1;
  overflow-wrap: break-word;
  font-weight: normal;
  border-bottom: 1px solid #bbbbbb;
  padding: 0 0 3px;
}

.form_styl1 table tr th a,
.form_styl1 table tr td a {
  text-align: left;
  padding: 10px 0px;
  font-size: 14px;
  color: #294799;
}

.form_styl1 .faq a {
  font-size: 16px;
  text-decoration: none;
  color: #005fb2;
  font-weight: 600;
}

.form_styl1 .faq a:hover {
  text-decoration: underline;
}

.distance_learn a {
  font-size: 14px;
  color: #000;
  line-height: 1.3;
  cursor: pointer;
}

.distance_learn a:hover {
  color: red;
  text-decoration: underline;
}

.distance_learn a i {
  margin-left: 4px;
}

.container_box .change_password p {
  color: #000;
  font-size: 13px;
  line-height: 1.3;
  text-align: left;
  padding-top: 5px;
}

.container_box .change_password {
  max-width: 300px;
  min-height: 280px;
  border-radius: 20px;
  background: #fff;
  margin: 20px auto;
  padding: 15px 15px 5px 15px;
  box-shadow: 3px 3px 10px #999;
}


.change_password .input_box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.change_password .input_box label {
  background: transparent;
  padding: 10px 0px;
  width: 100%;
  text-align: left;
  color: #000;
  font-size: 14px;
}

.change_password input.button_styl {
  background: #00115e;
  color: #fff;
  margin-top: 20px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  text-align: center;
  max-width: 92%;
  padding: 10px;
}

.change_password input {
  border: 1px solid #ccc;
  width: 100%;
  outline: none;
  max-width: 90%;
}

.change_password input[type="checkbox"] {
  border: 1px solid #ccc;
  margin: 0px 5px;
  width: 16px;
  outline: none;
  height: 16px;
  accent-color: green;
}

.change_password label.green_txt {
  color: green !important;
}

.change_password input[type="radio"] {
  border: 1px solid #ccc;
  padding: 18px;
  outline: none;
  width: 20px;
}

.change_password span.radio_styl {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 10px;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}

.change_password .input_box span.radio_styl label {
  background: transparent;
  padding: 5px 0px;
  width: 100%;
  text-align: left;
  color: #000;
  font-weight: 600;
  font-size: 12px;
  margin: 0;
}

.container_box h4 {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  padding-top: 40px;
}

.container_box p {
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  margin: 0;
  padding: 0px 0px 10px 0px;
}

.container_box .reset_password {
  background: transparent !important;
  margin: 0 auto !important;
  min-height: 375px;
  box-shadow: none;
}

.reset_password .input_box label i {
  position: relative;
  top: 40px;
  color: #000;
  left: 10px;
}

.reset_password input {
  border: 1px solid #eee;
  padding: 0px 0px 0px 30px;
  width: 100%;
  outline: none;
}

.reset_password input.button_styl {
  background-color: red;
}

.reset_top h4 {
  padding-top: 60px;
}

.reset_top p {
  padding-top: 10px;
  line-height: 1.5;
}

.myImage {
  width: 40%;
  height: auto;
  background-repeat: no-repeat;
  background-size: 40%;
  text-align: center;
  box-shadow: 2px 2px 5px #999;
}

.text-center {
  text-align: center !important;
}

.text-left {
  text-align: left !important;
}

input.Continue,
button.Continue {
  background: red;
  color: #fff;
  width: 12%;
  margin: 0 auto;
  margin-top: 20px;
  outline: none;
  font-size: 14px;
  font-weight: 600;
  padding: 7px;
  border: none;
  cursor: pointer;
  border-radius: 3px;
}

.faq h4 {
  font-size: 16px;
  padding: 0;
  line-height: 24px;
  border-bottom: 1.5px solid #727272;
  padding-bottom: 5px;
  font-weight: 600;
}

.faqlist h4 {
  border-bottom: 1px solid #bbbbbb;
  font-weight: 600;
  cursor: pointer;
}

.faq h3 {
  border: none;
  font-weight: 600;
  font-size: 21px;
  margin: 0;
}

.container_body .faq .form_styl p {
  font-size: 11px;
  color: #585858;
  overflow-wrap: break-word;
  font-weight: normal;
}

.container_body .faq .form_styl .faq_text p {
  font-size: 13px;
  padding: 3px 0px;
}

.container_body .faq .form_styl .faq_text p span {
  color: #585858 !important;
  font-weight: normal;
  font-size: 13px !important;
  text-align: left;
  line-height: 1;
  font-family: 'Lato', sans-serif;
  ;
}

.container_body .faq .form_styl .faq_text p a span {
  color: #294799 !important;
  cursor: pointer;
}

.faq_text {
  padding: 0px;
  border-bottom: 1px solid #bbbbbb;
  border-radius: 0px;
  margin-bottom: 10px;
  resize: none;
  min-height: 35px;
  height: auto;
  font-size: 13px;
  overflow: hidden;
  cursor: none;
}

.container_body .faq .form_styl p a {
  font-size: 13px !important;
  color: #294799 !important;
  padding: 0px;
  cursor: pointer;
  font-weight: normal;
}

.faq_tags {
  padding: 20px 0px;
  border-top: 1px solid #bbbbbb;
  margin-top: 10px;
}

.faq_tags a {
  color: #27599a;
  border: 1px solid #27599a;
  text-decoration: none;
  padding: 5px 20px;
  border-radius: 30px;
  font-size: 12px !important;
  font-weight: normal;
  margin: 0px 5px;
  cursor: pointer;
}

.commntbox {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border: 1px solid #ccc;
  padding: 5px 3px;
  margin: 20px 0px 40px 0px;
}

.commntbox .w33 p {
  padding: 3px 10px;
}

.commntbox a {
  text-decoration: none;
  font-size: 11px;
}

.commntbox i {
  color: #7a7979;
  border: 1px solid #ccc;
  padding: 5px;
}

.faq .inner_part input {
  padding: 7px;
  border-bottom: 1px solid #bbbbbb;
  border-radius: 0px;
  margin-bottom: 10px;
  border-top: none;
  border-left: none;
  border-right: none;
}

.faq .inner_part input:disabled {
  background: transparent;
  padding: 2px;
}

.clender_styl .react-date-picker__wrapper {
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  border: thin solid #bbbbbb;
  border-radius: 4px;
  width: 100%;
}

.clender_styl .react-date-picker__inputGroup__input {
  height: auto;
  padding: 0 7px !important;
  border: none !important;
}

.clender_styl .react-date-picker__inputGroup {
  height: 29px;
}

.clender_styl .react-date-picker {
  width: 100%;
}

.Toastify__toast--success {
  background: #07bc0c;
}

.Toastify__toast--error {
  background: #e74c3c;
}

.container_box .reset_email p {
  color: #000;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
  font-weight: 600;
  text-align: justify;
  padding-bottom: 10px;
}

.container_box .reset_email h4 {
  text-align: center;
  font-size: 24px;
  font-weight: 400;
  width: 100%;
  margin: 0;
  padding: 10px 0px;
}

.container_box .reset_email a {
  text-decoration: none;
  color: #000f59;
  padding: 15px 0px;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
}

.container_box .reset_email p span {
  background: #fff;
}

.container_box .reset_email a:hover {
  text-decoration: underline;
  color: #000f59;
}

.text_red {
  color: red;
}

.container_box .reset_email {
  padding: 00px 0px;
  flex-wrap: wrap;
  align-content: center;
  min-height: 100vh;
  justify-content: center;
  align-items: center;
}

.container_box .reset_email .input_box {
  max-width: 310px;
  border-radius: 10px;
  /* background: #fff; */
  margin: 0 auto;
  padding: 15px 15px 15px 15px;
  /* box-shadow: 3px 3px 10px #999; */
  text-align: center;
}



.Toastify__toast-theme--light p {
  color: #fff;
  font-size: 14px;
  margin: 0;
}

.Toastify__toast-theme--light svg {
  fill: #fff;
}

.Toastify__close-button svg {
  border: 1px solid #fff;
  padding: 3px;
  fill: #fff;
}

.clender_styl .react-date-picker.error_msg {
  outline: red;
  border: 1.5px solid red;
  margin-bottom: 0px;
  border-radius: 5px;
}

span.clender_styl {
  display: flex;
  flex-direction: column;
}

.sharebox input.submit,
.Commentbox input.submit {
  float: right;
}

.Commentbox input.submit {
  width: auto;
  padding: 7px 10px;
}

.sharebox textarea {
  padding: 10px;
  width: 97%;
  font-family: 'Lato', sans-serif;
  resize: vertical;
}

a.attchfile,
span.attchfile {
  background: #999;
  color: #fff;
  margin: 0 auto;
  outline: none;
  font-size: 15px;
  font-weight: 400;
  padding: 7px;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  top: 25px;
  position: relative;
}

.form_styl .sharebox h4 {
  font-size: 20px;
  font-weight: 600;
}

.m_auto {
  margin: 0 auto;
}

.sharechat img,
.sharechat i {
  border-radius: 50%;
  padding: 7px;
  width: 16px;
  height: 16px;
  background: #8199af;
  font-size: 14px;
  text-align: center;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sharechat {
  display: flex;
  padding: 15px 10px;
  width: 100%;
  background: #fff;
  box-sizing: border-box;
}

.container_body .form_styl .sharechat p {
  color: #3c3c3c;
  padding: 0px 15px;
  font-weight: normal;
  line-height: 1.3;
}

.container_body .form_styl .sharechat a {
  font-weight: normal;
  text-decoration: none;
  font-weight: 600;
}

.sharechatinner {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  border: 1px solid #ccc;
  margin: 20px 7px 10px 60px;
  padding: 10px;
  width: 100%;
}

.subchatbox {
  background: #eee;
  /* padding: 10px 5px;    */
}

.container_body .comentpart p {
  /* padding: 6px 5px;
  background: #fff;
  border-radius: 5px;
  width: 97%;
  min-height: 40px;
  word-break: break-all;
  border: 1px solid #dadada; */
  padding-left: 0;
  border: 0;
  color: red;
}

.sharecomment {
  border: 1px solid #ccc;
  padding: 10px 15px;
  background: #f3f3f3;
  margin: 20px 0px;
}

.comentpart {
  padding: 10px 0px;
  width: 100%;
}

.comentpartfull {
  padding: 0px;
  width: 100%;
}

.comentpart textarea {
  width: 100%;
  font-size: 13px;
  padding: 5px;
  border: 1px solid #ccc;
  font-family: 'Lato', sans-serif;
}

.comentpart span.comntbtn {
  padding-left: 12px;
  min-width: 15%;
  text-align: center;
}

.comentpart span {
  padding: 0px;
  text-align: center;
}

.comentpart span i {
  background: #c1e3e7;
  padding: 10px;
  border-radius: 6px;
}

.replycommnt {
  width: 100%;
  padding: 15px 0px 10px 0px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.replycommntleft {
  width: 100%;
  padding: 15px 60px 10px 0px;
}

.replycommntfull {
  width: 100%;
  padding: 15px 0px 10px 0px;
}

.sharecomment .comentpart span p {
  padding: 6px 5px;
  background: #c1e3e7;
  border-radius: 10px;
  margin-top: 5px;
  font-weight: 600;
  min-height: auto;
  cursor: pointer;
}

.sharecomment .comentpart span p i {
  padding: 0px 4px;
}

.container_body .commentParrts p.datetimecomment {
  padding: 5px 0;

  color: #00000099;
  font-size: 14px;
}

.commentParrts {
  padding-left: 14px;
}

.sharechat p.rcorners1 {
  font-size: 15px;
  line-height: 1.5;
  font-weight: 400 !important;
  color: #005fb2;
  display: inline-block;
  border-bottom: 1px dotted #ccc;
  padding: 0px !important;
  word-break: break-word;
  text-transform: capitalize;
}

.sharechat p.rcorners2 {
  color: red;
  font-size: 14px;
  padding: 0;
  border-bottom: 0;
  word-break: break-all;
  line-height: 1.5;
}

.sharechat p.rcorners2 p {
  padding: 0;
}

.sharechat p a {
  font-size: 13px;
  color: #337ab7;
  font-weight: 600;
}

.inner_part textarea {
  padding: 7px;
  border: 1px solid #bbbbbb;
  border-radius: 4px;
  margin-bottom: 10px;
  resize: vertical;
  font-family: 'Lato', sans-serif;
}

.faq .form_styl .inner_part textarea {
  padding: 7px;
  border-bottom: 1px solid #bbbbbb;
  border-radius: 0px;
  margin-bottom: 10px;
  resize: none;
  min-height: 45px;
  height: auto;
  font-size: 12px;
  /* border-top: none;
  border-left: none;
  border-right: none; */
}

.inner_part textarea:disabled,
.faq .form_styl .inner_part textarea:disabled {
  background: #eee;
  border-bottom: 1px solid #ccc;
}


.inner_part i.iconstyl {
  display: block;
  position: relative;
  left: 365px;
  top: -32px;
  font-size: 13px;
  color: #666;
  cursor: auto;
}

/* .change_password 
 input[type="checkbox"] {
    border: 1px solid #ccc;
    padding: 10px;
    width: 6%;
    background: green;
    color: #fff;
} */
.error_text {
  position: relative;
  right: 10px;
  float: right;
  display: block;
  text-align: right;
  top: -27px;
}

.w100.innercomment {
  margin-top: 10px;
}

.dropdown {
  display: block;
  background: #fff;
  border-radius: 7px;
  margin: 0;
  padding: 0;
  position: absolute;
  border: 1px solid #eee;
  box-shadow: 0px 2px 5px #5a5a5a;
  margin-left: 25px;
}

.dropdown::before {
  content: '';
  position: absolute;
  border: 10px solid transparent;
  border-bottom: 10px solid #fff;
  top: -20px;
  left: 7px;
}

.dropdown ul {
  padding: 0;
  margin: 0;
  width: 140px;
}

.dropdown ul li {
  list-style: none;
  font-size: 14px;
  line-height: 1.4;
  padding: 5px 10px;
  cursor: pointer;
  color: #000f59;
}

.dropdown ul li a {
  list-style: none;
  font-size: 14px;
  line-height: 1.4;
  cursor: pointer;
  color: #000f59;
}

.dropdown ul li i {
  font-size: 12px;
  color: #000f59;
  vertical-align: baseline;
  padding-right: 3px;
}

.dropdown ul li:hover {
  background: #eee;
  border-radius: 7px;
}

.password-good-color {
  color: green;
}

.password-message {
  display: block;
  line-height: 45px;
  font-size: 10px;
  padding: 0 10px;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
}

.addnewrecord {
  display: flex;
  justify-content: flex-end;
}

.addnewrecord a,
.addnewrecord span {
  text-decoration: none;
  font-weight: 600;
  font-size: 13px;
  color: #27599a;
  margin-left: 15px;
  background: #eee;
  padding: 2px 5px;
  border-radius: 5px;
  cursor: pointer;
}

.addnewrecord a:hover,
.addnewrecord span:hover {
  background: #27599a;
  color: #fff !important;
  text-decoration: none;
}

.removerecord {
  display: flex;
  justify-content: flex-end;
}

.removerecord a,
.removerecord span {
  text-decoration: none;
  font-weight: 600;
  font-size: 13px;
  color: red;
  margin-left: 15px;
  background: #eee;
  padding: 2px 5px;
  border-radius: 5px;
  cursor: pointer;
}

.removerecord a:hover,
.removerecord span:hover {
  background: red;
  color: #fff;
}

.orgstyl {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  background: #eee;
  padding: 0px 10px;
  cursor: pointer;
}

.orgstyl h4 {
  margin: 0;
  padding: 10px 0px;
  font-size: 16px;
}

span.worklocation {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

span.worklocation input[type="text"] {
  width: 90%;
  border: 1px solid #bbbbbb;
  border-radius: 4px;
  padding: 7px 5px;
}

span.worklocation label {
  color: black;
}

.inner_part3 {
  display: flex;
  flex-direction: row;
  width: 49%;
}

.form_part {
  padding-top: 10px;
  padding-bottom: 100px;
}

.blctext b {
  line-height: 1.6;
}

.blctext h2 {
  margin: 0;
  padding: 5px 0px;
  font-size: 25px;
  font-weight: 700;
}

.heading_styl h4 {
  color: #fff;
  padding: 10px;
  /* font-size: 1.125rem; */
}

button:disabled,
button {
  padding: 10px;
  margin-top: 10px;
}

button:disabled.react-date-picker__button {
  padding: 7px;
  margin-top: 0px;
}

.error_green {
  color: green;
  font-size: 13px;
  line-height: 1.3;
  font-weight: normal;
}



/* ----- Create a custom checkbox ---- */
.input_box .radio_styl input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.input_box span.radio_styl .checkmark {
  position: absolute;
  top: 3px;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #eee;
  border-radius: 30px;
  border: 1px solid #ccc;
}

span.radio_styl input:hover input~.checkmark {
  background-color: #ccc;
}

span.radio_styl input:checked~.checkmark {
  background-color: green;
}

span.radio_styl .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

span.radio_styl input:checked~.checkmark:after {
  display: block;
}

span.radio_styl .checkmark:after {
  left: 5px;
  top: 2px;
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

/* ----- End Create a custom checkbox ---- */


.form_styl ul {
  margin: 0;
  padding: 20px;
}

.form_styl ul li {
  list-style: none;
  color: black;
  font-weight: normal;
  line-height: 1.5;
}

.form_sec .form_styl .paymentsyl p {
  font-size: 13px;
  text-align: justify;
  padding: 0px 0px 0px 0px;
  color: #000 !important;
  line-height: 20px;
  padding-top: 10px;
  font-weight: 400;
  cursor: auto;
}

.form_sec .form_styl .paymentsyl ul li {
  font-size: 13px;
  text-align: justify;
  padding: 0px 0px 5px 0px;
  color: #000;
  line-height: 1.4;
  font-weight: 400;
  cursor: auto;
  list-style: initial;
}

.form_sec .form_styl .paymentsyl ul li:first-child {
  list-style: none;
  margin-left: -18px;
}

.form_sec .form_styl .paymentsyl strong.red {
  color: red;
}

.form_sec .form_styl .paymentsyl ul li input {
  border: 1px solid #bbbbbb;
  border-radius: 4px;
  vertical-align: bottom;
  margin-bottom: 3px;
  padding: 0;
  margin-left: 0;
}

.form_styl .inner_part p {
  color: black;
  padding: 10px 0px;
}




.checkbox_styl {
  padding: 0px;
  justify-content: flex-start;
  align-items: center;
}

.scroll_styl .heading_styl.head_font h4,
.container_body .heading_styl.head_font h4 {
  font-size: 18px;
}

.blc_txt span {
  color: black !important;
  font-weight: normal;
  cursor: auto;
}

.blc_txt span:hover {
  text-decoration: none;
  cursor: auto;
}


.w100.innercomment textarea {
  width: 640px;
  margin-left: 15px;
  border: 1px solid #ccc;
  padding: 5px;
}

.inner_part input.react-date-picker__inputGroup__input {
  margin: 6px 0px 0px 0px;
  height: 15px;
  border: none !important;
  padding: 0;
  font-size: 13px;
  font-weight: 400;
  color: black;
}

.inner_part input.react-date-picker__inputGroup__input:disabled {
  color: #a1a1a1;
}

.react-date-picker__wrapper {
  height: 34px;
  border: 1px solid #bbbbbb;
  border-radius: 3px;
}

.react-date-picker__inputGroup {
  padding: 3px 7px;
}

.react-date-picker__button {
  margin: 0;
}

.dashboard_note {
  background: #eee;
  padding: 10px;
  width: 96%;
  margin: 0px 30px;
}

.dashboard_note p {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #294799;
  line-height: 1.5;
}

.container_body.signinredrct {
  /* border: 1px solid #c3d6e3; */
  min-height: 500px;
  margin: 45px auto;
  /* background: rgb(244 244 244 / 85%); */
  padding: 30px 10px;
  max-width: 1020px;
  margin: 0 auto;
  margin-top: 40px;
  text-align: center;
}

.signinredrct button.submit {
  max-width: 12%;
}

.sharebtm {
  display: flex;
  align-items: baseline;
  width: 100%;
  justify-content: space-between;
  flex-direction: row;
}

.signin_head {
  max-width: 330px;
  margin: 0 auto;
}

.signin_head h4 {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.8);
  font-weight: 600;
  padding-top: 30px;
  line-height: 1.5;
  text-transform: uppercase;
}

.container_box .signin_head p {
  line-height: 1.4;
  padding-top: 5px;
  color: #666;
  font-size: 16px;
  padding-bottom: 0;
}


select.react-date-picker__inputGroup__input {
  padding: 0;
  border: none;
  appearance: none;
  min-width: 20px;
  font-size: 13px;
  color: black;
  font-weight: 400;
}


.container_body .sidebar p {
  color: red;
  text-align: left;
  padding-top: 5px;
}

a.regagain {
  padding-top: 25px;
  display: block;
  cursor: pointer;
  max-width: 15%;
  font-weight: 600;
  font-size: 14px;
}

.uploadpic {
  display: flex;
  flex-direction: column;
}

.uploadpic span {
  padding-top: 3px;
}

.uploaddoc span.uploadfile,
.uploadpic span.uploadfile {
  padding: 5px 0px;
  color: #EA001c !important;
  cursor: pointer;
}

.form_styl .uploadpic span.uploadfile_styl {
  padding: 3px 10px;
  color: #000 !important;
  cursor: pointer;
  background: #eee;
  border: 1px solid #ccc;
}

.uploaddoc span.uploadfile i {
  padding-right: 2px;
}

.uploaddoc span {
  padding: 0px 5px;
}

.react-date-picker__clear-button {
  position: absolute;
  right: 32px;
  top: -3px;
  width: 25px;
  height: 25px;

}

.react-date-picker__clear-button:before,
.react-date-picker__clear-button:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 15px;
  width: 2px;
  background-color: #333;
}

.react-date-picker__clear-button:before {
  transform: rotate(45deg);
}

.react-date-picker__clear-button:after {
  transform: rotate(-45deg);
}

/* .rs-loader .rs-loader-spin, .rs-loader .rs-loader-spin:after, .rs-loader .rs-loader-spin:before {
  height: 18px;
  width: 18px;
}

.rs-loader-speed-normal .rs-loader-spin:after {
  -webkit-animation-duration: .6s;
  animation-duration: .6s;
} */








/* HTML: <div class="loader"></div> */
/* .loaderstyl {
  border: 7px solid #f3f3f3;
  border-radius: 50%;
  border-top: 7px solid #132fbd;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
 
  animation: spin 2s linear infinite;
} */

/* HTML: <div class="loader"></div> */

/* .loader_back{
  position: "fixed";
  top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.5);
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 2;
                backdrop-filter: blur(8px);
} */

.loaderstyl {
  width: 60px;
  aspect-ratio: 2;
  --_g: no-repeat radial-gradient(farthest-side, #000 90%, #0000);
  background:
    var(--_g) 0 50%,
    var(--_g) 50% 50%,
    var(--_g) 50% 50%,
    var(--_g) 100% 50%;
  background-size: 25% 50%;
  animation: l12 1s infinite linear;
}

/* payment loader*/



@keyframes l12 {
  33% {
    background-position: 0 0, 50% 100%, 50% 100%, 100% 0
  }

  66% {
    background-position: 50% 0, 0 100%, 100% 100%, 50% 0
  }

  100% {
    background-position: 50% 50%, 0 50%, 100% 50%, 50% 50%
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}






/* HTML: <div class="loader"></div> */
/* HTML: <div class="loader"></div> */
.loader {
  --s: 28px;
  height: var(--s);
  aspect-ratio: 2.5;
  --_g: #000 90%, #0000;
  --_g0: no-repeat radial-gradient(farthest-side, var(--_g));
  --_g1: no-repeat radial-gradient(farthest-side at top, var(--_g));
  --_g2: no-repeat radial-gradient(farthest-side at bottom, var(--_g));
  background: var(--_g0), var(--_g1), var(--_g2), var(--_g0), var(--_g1), var(--_g2);
  background-size: 20% 50%, 20% 25%, 20% 25%;
  animation: l45 1s infinite;
}

@keyframes l45 {
  0% {
    background-position: calc(0*100%/3) 50%, calc(1*100%/3) calc(50% + calc(var(--s)/8)), calc(1*100%/3) calc(50% - calc(var(--s)/8)), calc(3*100%/3) 50%, calc(2*100%/3) calc(50% + calc(var(--s)/8)), calc(2*100%/3) calc(50% - calc(var(--s)/8))
  }

  33% {
    background-position: calc(0*100%/3) 50%, calc(1*100%/3) 100%, calc(1*100%/3) 0, calc(3*100%/3) 50%, calc(2*100%/3) 100%, calc(2*100%/3) 0
  }

  66% {
    background-position: calc(1*100%/3) 50%, calc(0*100%/3) 100%, calc(0*100%/3) 0, calc(2*100%/3) 50%, calc(3*100%/3) 100%, calc(3*100%/3) 0
  }

  90%,
  100% {
    background-position: calc(1*100%/3) 50%, calc(0*100%/3) calc(50% + calc(var(--s)/8)), calc(0*100%/3) calc(50% - calc(var(--s)/8)), calc(2*100%/3) 50%, calc(3*100%/3) calc(50% + calc(var(--s)/8)), calc(3*100%/3) calc(50% - calc(var(--s)/8))
  }
}

.loader-content {
  width: auto !important;
  margin: auto !important;
  border-radius: 9.3rem !important;
}

span.clender_styl input {
  padding: 7px;
  border: 1px solid #bbbbbb;
  border-radius: 4px;
  margin-bottom: 10px;
  width: 97%;
}

.main_container.login_main_container .container_box {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

@media screen and (min-width: 1921px) and (max-width: 4720px) {

  .container_body .home_sec,
  .container_body .home_app {
    width: 100% !important;
  }

  .footer_box {
    width: 95%;
  }

  /* .container_box { 
    min-height: 100%;
  } */
}


@media screen and (min-width: 1201px) and (max-width: 1250px) {
  .container_body {
    max-width: 1145px;
  }

  .top_header {
    max-width: 1145px;
  }

  .menu_header {
    max-width: 1145px;
  }

  .container_box {
    min-height: 100%;
  }

}

@media screen and (min-width: 1300px) and (max-width: 1420px) {
  .container_body {
    max-width: 1280px;
  }

  .top_header {
    max-width: 1280px;
  }

  .menu_header {
    max-width: 1280px;
  }

}

@media screen and (min-width: 1421px) and (max-width: 1720px) {
  .container_body {
    max-width: 1380px;
  }

  .top_header {
    max-width: 1380px;
  }

  .menu_header {
    max-width: 1380px;
  }

  .container_body .home_sec,
  .container_body .home_app {
    width: 100% !important;
  }

  /* .container_box{
    min-height: 100%;
  } */
  /* .main_container .container_box {
    min-height: 100%;
} */
}


@media screen and (min-width: 1721px) and (max-width: 1920px) {
  .container_body {
    max-width: 1680px;
  }

  .top_header {
    max-width: 1680px;
  }

  .menu_header {
    max-width: 1680px;
  }

  .right_panel .scroll_styl {
    max-height: 600px;
  }

}


@media (max-width: 1023px) {
  .sidebar {
    width: 35%;
    border: none;
  }

  .container_body {
    padding: 10px 5px;
  }

  .sidebar ul {
    margin: 0;
    padding: 10px 5px 0px 5px;
  }

  .sidebar ul li.active {
    padding: 7px 2px;
  }

  .sidebar ul li a {
    font-size: 13px;
    padding: 7px 2px;
    display: flex;
    line-height: 1.5;
  }

  .right_panel {
    padding: 10px 10px;
    width: 65%;
  }

  .user_profile {
    width: 55%;
  }

  .sidebar ul li {
    padding: 2px 6px;
  }

  .sidebar ul li.active {
    padding: 7px 2px;
  }

  .sidebar ul li a {
    font-size: 14px;
    padding: 7px 2px;
    display: flex;
    line-height: 1.5;
  }

  .right_panel {
    padding: 10px 10px;
    width: 65%;
  }

  .user_profile {
    width: 100%;
  }

  .sidebar ul li {
    padding: 2px 6px;
  }

  .right_panel .scroll_styl {
    overflow-y: auto;
    max-height: 100%;
  }

  .form_part .form_styl .inner_part1 .heading_styl h4,
  .form_styl .heading_styl h4,
  .heading_styl h4 {
    font-size: 16px;
  }

  .form_sec {
    padding: 10px 10px 20px 10px;
  }

  input.submit,
  button.submit {
    width: 35%;
  }

  .sharebox textarea {
    padding: 5px;
    max-width: 98%;
    resize: none;
  }

  .w66 {
    padding: 0px 5px;
  }

  .w33 {
    width: 30%;
    padding: 0px 7px;
  }

  .comentpart span {
    min-width: 20%;
  }

  .container_body .comentpart p {
    width: 76%;
  }

  .logostyl img {
    max-width: 130px;
    padding: 3px 0px 0px 9px;
  }

  .form_styl.Work_experience {
    align-items: end;
  }
}


@media (max-width: 576px) {
  .container_box .login_box {
    max-width: 240px;
    min-height: 285px;
  }

  .container_box .signup_box {
    max-width: 240px;
    min-height: 425px;
    padding: 20px 20px 15px 20px;
  }

  .form_sec {
    width: 100% !important;
    padding: 10px 7px 20px 7px;
  }

  .form_styl {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .inner_part,
  .inner_part1 {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .inner_part select {
    width: 97%;
  }

  .inner_part input,
  .inner_part1 input,
  .inner_part2 input {
    width: 96%;
  }

  .form_sec_inner {
    width: 90% !important;
    padding: 0px 10px 10px 10px;
  }

  .user_profile {
    width: 100%;
  }

  .profile_box {
    width: 100%;
  }

  .nav_link {
    width: 100%;
  }

  .home_sec {
    width: 86% !important;
  }

  .home_app {
    width: 98% !important;
  }

  .container_body.flex {
    flex-direction: column;
    width: 95%;
    padding: 10px 0px;
  }

  .sidebar {
    width: 100%;
    border: none;
    height: auto;
  }

  .right_panel {
    padding: 10px 0px;
    width: 100%;
  }

  .right_panel .scroll_styl {
    overflow-y: auto;
    max-height: 100%;
    padding-right: 0px;
  }

  input.submit,
  button.submit {
    width: 40%;
  }

  .w33 {
    width: 100%;
    padding: 0px;
  }

  .w66 {
    padding: 0px;
    width: 100%;
  }

  .sharechatinner {
    width: 85%;
    margin: 15px 0px 0px 42px;
  }

  .comentpart span {
    min-width: 21%;
  }

  .container_body .comentpart p {
    width: 75%;
  }

  .main_part {
    width: 95%;
    max-width: 100%;
    margin: 0 auto;
  }

  .progressbar {
    width: 100%;
    margin: 0px;
  }

  .right_panel .dflex h4.top_head,
  .right_panel .dflex h4,
  .right_panel .w100 h4.top_head {
    font-size: 14px;
  }

  .container_body p {
    font-size: 12px;
    padding: 0px 0px;
  }

  span.help_link p a {
    font-size: 12px;
  }


}

.txt {
  border-style: none;
  border-color: Transparent;
  overflow: auto;
}

.form_styl a.cButton {
  display: block;
  width: 115px;
  background: red;
  padding: 3px 5px;
  text-align: center;
  border-radius: 5px;
  color: white;
  font-weight: bold;
  margin-top: 10px;
  font-size: 14px;
  cursor: pointer;
  margin: 0 auto;
}

.form_styl a.cButton:hover {
  text-decoration: none;
}

.rcorners1 {
  /* border-radius: 10px;
  border: 0.2px solid #8da1cd; */
  /* padding: 20px;
  width: 200px;
  height: 150px; */
}


.rcorners2 {
  /* border-radius: 10px;
  border: 0.3px solid #b4baac; */
  /* padding: 20px;
  width: 200px;
  height: 150px; */
}

.inner_part.textAreaminhgt textarea {
  min-height: 105px;
}


/* calender */
.react-date-picker {
  display: inline-flex;
  position: relative;
}

.react-date-picker,
.react-date-picker *,
.react-date-picker *:before,
.react-date-picker *:after {
  box-sizing: border-box;
}

.react-date-picker--disabled {
  background-color: #f0f0f0;
  color: #6d6d6d;
}

.react-date-picker__wrapper {
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  border: thin solid gray;
}

.react-date-picker__inputGroup {
  min-width: calc((4px 3) + 0.54em 8 + 0.217em * 2);
  flex-grow: 1;
  padding: 0 2px;
  box-sizing: content-box;
}

.react-date-picker__inputGroup__divider {
  padding: 1px 0;
  white-space: pre;
}

.react-date-picker__inputGroup__divider,
.react-date-picker__inputGroup__leadingZero {
  display: inline-block;
  font: inherit;
}

.react-date-picker__inputGroup__input {
  min-width: 0.54em;
  height: 100%;
  position: relative;
  padding: 0 1px;
  border: 0;
  background: none;
  color: currentColor;
  font: inherit;
  box-sizing: content-box;
  appearance: textfield;
}

.react-date-picker__inputGroup__input::-webkit-outer-spin-button,
.react-date-picker__inputGroup__input::-webkit-inner-spin-button {
  appearance: none;
  margin: 0;
}

.react-date-picker__inputGroup__input:invalid {
  background: rgba(255, 0, 0, 0.1);
}

.react-date-picker__inputGroup__input--hasLeadingZero {
  margin-left: -0.54em;
  padding-left: calc(1px + 0.54em);
}

.react-date-picker__button {
  border: 0;
  background: transparent;
  padding: 4px 6px;
}

.react-date-picker__button:enabled {
  cursor: pointer;
}

.react-date-picker__button:enabled:hover .react-date-picker__button__icon,
.react-date-picker__button:enabled:focus .react-date-picker__button__icon {
  stroke: #0078d7;
}

.react-date-picker__button:disabled .react-date-picker__button__icon {
  stroke: #6d6d6d;
}

.react-date-picker__button svg {
  display: inherit;
}

.react-date-picker__calendar {
  width: 350px;
  max-width: 100vw;
  z-index: 1;
}

.react-date-picker__calendar--closed {
  display: none;
}

.react-date-picker__calendar .react-calendar {
  border-width: thin;
}

.autoText {
  padding: 0.5em;
  /* background-color:pink; */
  /* padding: 10px; */
  width: 97%;
  font-family: 'Lato', sans-serif;

  border: 1px solid #bbbbbb;
  border-radius: 4px;
  margin-bottom: 10px;

}

.container_box .footer_box h4 {
  padding-top: 0px;
  padding-bottom: 10px;
  text-align: left;
}

.footer_box .notify p {
  text-align: left;
  font-family: 'Lato', sans-serif !important;
  line-height: 1.6;
  color: #2b4e99;
  padding: 6px 0;
  font-size: 1em;
}

/* .footer_box .notify p strong{
  color: rgb(43, 78, 153);
  font-weight: 600;
} */
.display_inblock {
  display: inline-block !important;
}

.casesedtl .inner_part {
  width: 100%;
}

.casesedtl .form_styl {
  flex-wrap: wrap;
}

/* commentbox */

.Commentbox input {
  width: 97%;
  border: 1px solid #dadada;
  border-radius: 5px;
  padding: 10px 10px;
  outline: none;
}

.Commentbox ul {
  margin: 0px 0 10px;
  padding-left: 0;
}

.Commentbox ul li {
  list-style: none;
  font-size: 14px;
}

.Commentbox ul li i {
  margin-right: 5px;
}

.userProicon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.userProicon img {
  border-radius: 50%;
  width: 100%;
}

.userCommentinput {
  display: flex;
  justify-content: left;
  align-items: center;
}

.userCommentinput label {
  width: calc(100% - 40px);
}
/* .raisequerydesc {
  padding-bottom: 10px;
  border-bottom: 1px solid #bbb;
} */
.casesedtl button#rs-\\:r0\\:-btn {
  border-bottom: 1px solid #bbb;
  border-radius: 0;
}
.form_sec .form_styl .inner_part p.note_pg{
  color: #000 !important;
}
.align_end{
align-items: flex-end;
}
.flex-wrap{
  flex-wrap: wrap;
}
.justify_center{
  justify-content: center;
}
.in_notes p{
  margin-bottom: -3px;
}
.Addchat_image img{
  width: 200px !important;
  height: 200px;
  border-radius: 5px;
  background: none;
  padding: 0;
  margin: 20px 10px 20px 0px;
  /* margin-right: 15px; */
  border: 1px solid red;
}
.form_sec .form_styl p a:hover{
  text-decoration: underline;
  color: #2f2fff !important;
}
.redirectnotes h5.pb1 {
  font-size: 16px;
}
.cat_pg_text{
  margin-bottom: 0;
}
.blc_txt p i:hover{
  color: #000 !important;
}
.form_styl table tr td i:hover{
  color: #000 !important;
}
.bottom_clr .blc_txt {
  margin-bottom: 0px;
}
.container_body .form_styl .bottom_clr .blc_txt p:first-child{
  padding-top: 0;
}
a.linkcheckegi {
  color: #294799;
  font-weight: 700;
}
.communicationadd{
  padding-top: 19px;
}
.min_hgt_100{
  min-height: 100vh !important;
}

form .form_sec .form_styl .inner_part.notes_class {display: block;line-height: 16px;}

.inner_part.notes_class span {
    display: inline;
    line-height: 1.5;
}

.notes_class p {
  display: contents !important;
}

.container_body .form_sec .notes_class p {
  display: contents !important;
  font-size: 13px !important;
  color: #294799 !important;
}

.container_body .form_sec .notes_class.preview_note {
  font-size: 13px !important;
  color: #294799 !important;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;;AAGA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;;;;;GAOG;;AAEH;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,UAAU;EACV,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,YAAY;AACd;;AAEA;;;;;;;EAOE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,uDAAuD;AACzD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,uHAAuH;EACvH,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uDAAuD;EACvD,kBAAkB;AACpB;;AAEA;;;;EAIE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;EAKE,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;EAGE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,qBAAqB;AACvB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;EAIE,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,qBAAqB;AACvB;AACA;AACA,0BAA0B;AAC1B,eAAe;AACf;;AAEA;;EAEE,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;;;EAGE,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;EAGE,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;;EAGE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;EAsBE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,UAAU;AACZ;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,UAAU;AACZ;;;AAGA;;;;;;;;;;;;;;;;;;;;;EAqBE,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA;;;;EAIE,eAAe;EACf,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;;;EAGE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,uDAAuD;EACvD,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,UAAU;EACV,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,6BAA6B;AAC/B;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,+BAA+B;;AAEjC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,4BAA4B;EAC5B,mCAAmC;EACnC,kBAAkB;AACpB;;;;AAIA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE;;;;;;8BAM4B;EAC5B,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;;EAEd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,qBAAqB;EACrB,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf;;uBAEqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,6BAA6B;AAC/B;;;AAGA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;GAOG;AACH;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,8BAA8B;EAC9B,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;EACV,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;;;AAIA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,4CAA4C;;;AAG5C;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;;;;AAKA;EACE,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;;AAGA;EACE,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;;AAGA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;;AAGA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;;AAEd;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;;GAQG;;;;;;;;;AASH,qCAAqC;AACrC;;;;;;;;;GASG;;AAEH,qCAAqC;;AAErC;;;;;;;;;;;;GAYG;;AAEH;EACE,WAAW;EACX,eAAe;EACf,+DAA+D;EAC/D;;;;sBAIoB;EACpB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA,kBAAkB;;;;AAIlB;EACE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;;;;;AAOA,qCAAqC;AACrC,qCAAqC;AACrC;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,0DAA0D;EAC1D,iEAAiE;EACjE,oEAAoE;EACpE,kFAAkF;EAClF,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;;IAEE;EACF;AACF;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE;;IAEE,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;;EAEA;;KAEG;AACL;;;AAGA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;AAEF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;;KAEG;EACH;;GAEC;AACH;;;AAGA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;AAEF;;;AAGA;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;AACF;;;AAGA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;;EAEA;;IAEE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;;;IAGE,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;;AAGF;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;gCAC8B;EAC9B;;kBAEgB;AAClB;;;AAGA;EACE;gCAC8B;EAC9B;;kBAEgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA,aAAa;AACb;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;;EAME,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,iDAAiD;EACjD,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EAGvB,qBAAqB;AACvB;;AAEA;;EAIE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,+BAA+B;;EAE/B,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;;AAErB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;;;GAGG;AACH;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA,eAAe;;AAEf;EACE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;AACA;;;GAGG;AACH;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;AACA,qBAAqB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,0BAA0B;EAC1B,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;AAC9B;;AAEA,mDAAmD,cAAc,CAAC,iBAAiB,CAAC;;AAEpF;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B","sourcesContent":["@import url(\"https://fonts.cdnfonts.com/css/lato\");\r\n\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: 'Lato', sans-serif !important;\r\n}\r\n\r\n.center {\r\n  margin: auto;\r\n  width: 50%;\r\n  /* border: 3px solid green; */\r\n  padding: 10px;\r\n}\r\n\r\n.main_container {\r\n  width: 100%;\r\n  height: auto;\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: 'Lato', sans-serif !important;\r\n}\r\n\r\n.container_box {\r\n  max-width: 1240px;\r\n  height: auto;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  height: 100%;\r\n  min-height: 100vh;\r\n}\r\n\r\n.container_box form[name=\"signup\"] {\r\n  padding-top: 24px;\r\n}\r\n\r\n.header {\r\n  margin-top: 30px;\r\n  text-align: center;\r\n}\r\n\r\n.header img {\r\n  max-width: 180px;\r\n  margin-bottom: -20px;\r\n}\r\n\r\n.container_box .login_box,.container_box .signup_box  {\r\n  max-width: 280px;\r\n  /* min-height: 245px; */\r\n  border-radius: 30px;\r\n  background: #283c89;\r\n  margin: 20px auto 40px;\r\n  padding: 30px 30px 10px 30px;\r\n}\r\n\r\n.login_box .input_box {\r\n  margin-bottom: 10px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n}\r\n\r\n.input_box i {\r\n  color: #fff;\r\n}\r\n\r\n.input_box label {\r\n  background: #00115e;\r\n  padding: 13px;\r\n  width: 15%;\r\n  text-align: center;\r\n}\r\n\r\n.input_box input {\r\n  border: 1px solid #eee;\r\n  padding: 0px 15px;\r\n  width: 75%;\r\n  outline: none;\r\n  height: 45px;\r\n}\r\n\r\n.input_box input.button_styl,\r\n.input_box button.button_styl {\r\n  background: #00115e;\r\n  color: #fff;\r\n  margin-top: 10px;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  width: 100%;\r\n  border: none;\r\n  text-align: center;\r\n  padding: 12px;\r\n}\r\n\r\n.input_box button.red_button_styl {\r\n  background: red;\r\n  color: #fff;\r\n  margin-top: 10px;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  width: 100%;\r\n  border: none;\r\n  text-align: center;\r\n  padding: 15px;\r\n}\r\n\r\n.input_box a {\r\n  color: #fff;\r\n  font-size: 12px;\r\n  text-decoration: none;\r\n  /* font-weight: 600; */\r\n}\r\n\r\n.input_box.cancel_btn a {\r\n  color: #000;\r\n  font-size: 13px;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n}\r\n\r\n.input_box a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.footer_box {\r\n  background: #283c89;\r\n  padding: 10px 20px 20px 20px;\r\n  position: relative;\r\n  bottom: 0;\r\n  border-radius: 2px;\r\n  width: 96%;\r\n  margin: 0px auto 0;\r\n}\r\n\r\n.notify {\r\n  background: #fff;\r\n  padding: 4px 20px;\r\n  margin: 0;\r\n  border-bottom: 2px solid #283c89;\r\n  max-width: 100%;\r\n}\r\n\r\nhr {\r\n  margin-top: 15px;\r\n  margin-bottom: 15px;\r\n  border: 1px solid #dfdede;\r\n}\r\n\r\n\r\n.notify p {\r\n  font-size: 14px;\r\n  color: #005fb2;\r\n  margin: 0;\r\n  padding: 5px 0px;\r\n}\r\n\r\n.notify p a {\r\n  font-size: 1em;\r\n  color: #005fb2;\r\n  font-style: italic;\r\n  cursor: pointer;\r\n}\r\n\r\n.notify p a:hover {\r\n  color: #005fb2 !important;\r\n  text-decoration: underline;\r\n}\r\n\r\n.notify p i {\r\n  font-size: 14px;\r\n  color: #00A1E0;\r\n  padding: 0px 10px 0px 0px;\r\n}\r\n\r\n/* .container_box .signup_box {\r\n  max-width: 280px;\r\n  min-height: 280px;\r\n  border-radius: 30px;\r\n  background: #283c89;\r\n  margin: 20px auto;\r\n  padding: 20px 25px 5px 25px;\r\n} */\r\n\r\n.signup_box .input_box {\r\n  margin-bottom: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n}\r\n\r\n.input_box i {\r\n  color: #fff;\r\n}\r\n\r\n.signup_box .input_box label {\r\n  background: transparent;\r\n  padding: 5px 0px;\r\n  width: 100%;\r\n  text-align: left;\r\n  color: #fff;\r\n  font-size: 14px;\r\n}\r\n\r\n.signup_box input {\r\n  border: 1px solid #eee;\r\n  padding: 18px;\r\n  width: 65%;\r\n  outline: none;\r\n}\r\n\r\n.signup_box .input_box p {\r\n  text-align: center;\r\n  width: 100%;\r\n  color: #fff;\r\n  font-size: 14px;\r\n}\r\n\r\n.signup_box input {\r\n  border: 1px solid #eee;\r\n  padding: 0px 10px;\r\n  width: 93%;\r\n  outline: none;\r\n  height: 40px;\r\n}\r\n\r\n.form_styl input.error_msg,\r\n.form_styl div.error_msg,\r\n.form_styl textarea.error_msg,\r\n.form_styl1 .inner_part select.error_msg,\r\n.form_styl table td select.error_msg,\r\n.form_styl .inner_part select.error_msg,\r\n.form_styl .inner_part1 select.error_msg {\r\n  outline: red;\r\n  border: 1.5px solid red;\r\n  margin-bottom: 0px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.signup_box input.button_styl {\r\n  background: #00115e;\r\n  color: #fff;\r\n  margin-top: 20px;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  width: 92%;\r\n  border: none;\r\n  text-align: center;\r\n}\r\n\r\n.signup_box .input_box label span {\r\n  color: #EA001c;\r\n  font-size: 14px;\r\n}\r\n\r\n.main_header {\r\n  width: 100%;\r\n  height: auto;\r\n  margin: 0;\r\n  padding: 0;\r\n  background: linear-gradient(to right, #2b308b, #2572a3);\r\n}\r\n\r\n.top_header {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.logostyl img {\r\n  max-width: 120px;\r\n  padding: 3px 0px 0px 0px;\r\n}\r\ninput:-webkit-autofill {\r\n  background-color: transparent !important;\r\n}\r\n.user_profile {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  padding: 7px 0px;\r\n}\r\n\r\n.profile_box {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  width: 100%;\r\n  padding: 5px 25px;\r\n}\r\n\r\n.profile_box span {\r\n  background: #fff;\r\n  width: 35px;\r\n  height: 35px;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n}\r\n\r\n.profile_box span i {\r\n  font-size: 18px;\r\n  padding: 8px 10px;\r\n  color: #2669a0;\r\n}\r\n\r\n.profile_box h4 {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #fff;\r\n  margin: 0;\r\n  cursor: pointer;\r\n  padding-left: 5px;\r\n}\r\n\r\n.search_box {\r\n  background: #fff;\r\n  height: 20px;\r\n  padding: 3px;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  border-radius: 5px;\r\n}\r\n\r\n.search_box input {\r\n  width: 100%;\r\n  border: none;\r\n  outline: none;\r\n}\r\n\r\n.search_box i {\r\n  font-size: 12px;\r\n  padding: 0px 5px;\r\n}\r\n\r\n.main_menu {\r\n  width: 100%;\r\n  height: auto;\r\n  margin: 0;\r\n  padding: 0;\r\n  background: #000f59;\r\n}\r\n\r\n.menu_header {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  padding: 0px 10px;\r\n}\r\n\r\n.nav_link {\r\n  width: 35%;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 5px 0px;\r\n}\r\n\r\n.nav_link ul li,\r\n.nav_link ul li a {\r\n  display: inline-block;\r\n  color: #fff;\r\n  padding: 0px 20px 0px 0px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n}\r\n\r\n.nav_link ul {\r\n  margin: 0;\r\n  padding: 8px 0px;\r\n}\r\n\r\n.main_part {\r\n  width: 100%;\r\n  height: auto;\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: 'Lato', sans-serif;\r\n}\r\n\r\n.redirect_container {\r\n  background-image: url(https://apf-uat--uat.sandbox.my.site.com/admissions/file-asset/univ_building_8_reduced_image?v=1);\r\n  width: 100%;\r\n  min-height: 600px;\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  padding: 10px 0px;\r\n  min-height: 97vh;\r\n}\r\n\r\n.container_body {\r\n  max-width: 1200px;\r\n  width: 100%;\r\n  height: auto;\r\n  margin: 0 auto;\r\n  padding: 30px 0px;\r\n}\r\n\r\n.container_body p {\r\n  font-size: 14px;\r\n  margin: 0;\r\n  padding: 0px 15px;\r\n  line-height: 22px;\r\n}\r\n\r\n.w30 .form_styl1 .distance_learn p {\r\n  text-decoration: none;\r\n  padding: 10px 0px;\r\n  line-height: 1.3;\r\n  cursor: pointer;\r\n  border-bottom: 1.5px solid #727272;\r\n  color: #294799;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n}\r\n\r\n.w30 .form_styl1 .distance_learn p:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.w30 .form_styl1 .topic_art p {\r\n  text-decoration: underline;\r\n  padding: 5px 0px;\r\n  line-height: 1.3;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n}\r\n\r\n.w33 .form_styl1 .topic_art p:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.w33 .form_styl1 .topic_art p i {\r\n  margin-left: 3px;\r\n}\r\n\r\n.sub_topic {\r\n  padding: 5px 15px 15px;\r\n}\r\n\r\n.w33 .form_styl1 .topic_art .sub_topic p {\r\n  padding: 3px;\r\n}\r\n\r\n.home_app .form_styl1 .w100 p {\r\n  padding: 20px 0px 0px 0px;\r\n}\r\n\r\n.container_body .notes h4 {\r\n  font-size: 20px;\r\n  margin: 0;\r\n  padding: 0px 15px;\r\n  line-height: 26px;\r\n  font-weight: 600;\r\n}\r\n\r\n.container_body .redirectnotes h4 {\r\n  font-size: 20px;\r\n  margin: 0;\r\n  padding: 0px;\r\n  line-height: 2;\r\n  font-weight: 600;\r\n}\r\n\r\n.container_body .redirectnotes h4 {\r\n  font-size: 21px;\r\n  margin: 0;\r\n  padding: 0px;\r\n  line-height: 26px;\r\n  font-weight: 600;\r\n}\r\n\r\n.container_body .redirectnotes p,\r\n.signinredrct .redirectnotes a {\r\n  color: #294799;\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  padding: 0;\r\n  margin: 0 auto;\r\n}\r\n\r\n.signinredrct .redirectnotes a.cButton {\r\n  color: #fff;\r\n  padding: 3px;\r\n}\r\n\r\n\r\n.container_body .form_sec p {\r\n  padding: 0px;\r\n  font-size: 15px;\r\n}\r\n\r\n.container_body .notes p,\r\n.container_body .notes p a {\r\n  color: #294799;\r\n  font-weight: 700;\r\n  font-size: 15px;\r\n}\r\n\r\n.pb1 {\r\n  padding-bottom: 10px !important;\r\n}\r\n\r\n.container_body .notes span ol {\r\n  color: #294799;\r\n  display: block;\r\n  list-style-type: decimal;\r\n  margin-block-start: 1em;\r\n  margin-block-end: 1em;\r\n  margin-inline-start: 0px;\r\n  margin-inline-end: 0px;\r\n  padding-inline-start: 40px;\r\n  unicode-bidi: isolate;\r\n  font-weight: 700;\r\n  font-size: 15px;\r\n}\r\n\r\n.container_body .notes span ol li {\r\n  color: #294799;\r\n  display: list-item;\r\n  text-align: -webkit-match-parent;\r\n  unicode-bidi: isolate;\r\n  font-weight: 700;\r\n  font-size: 15px;\r\n}\r\n\r\n.heading_styl {\r\n  background: linear-gradient(to right, #2b308b, #2572a3);\r\n  border-radius: 5px;\r\n}\r\n\r\n.right_panel .form_styl .heading_styl h4,\r\n.right_panel .heading_styl h4,\r\n.form_styl .form_sec_inner .heading_styl h4,\r\n.heading_styl h4 {\r\n  font-size: 15px;\r\n  font-weight: 400;\r\n  color: #fff;\r\n  padding: 10px;\r\n  margin-bottom: 10px;\r\n  margin-top: 20px;\r\n  /* text-transform: uppercase; */\r\n}\r\n\r\n.form_part .form_styl .inner_part1 .heading_styl h4 {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #fff;\r\n  padding: 5px;\r\n  letter-spacing: 1px;\r\n  margin-top: 0px;\r\n  margin-bottom: 0px;\r\n  border: 1px solid #ccc;\r\n}\r\n\r\n.form_part span.redstyl,\r\np.redstyl,\r\nspan.redstyl,\r\n.form_styl span.redstyl,\r\n.sidebar p.redstyl {\r\n  font-size: 13px;\r\n  color: red !important;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  text-align: left;\r\n}\r\n\r\n.container_body .form_styl p {\r\n  font-size: 13px;\r\n  color: #294799;\r\n  cursor: auto;\r\n  font-weight: 600;\r\n  padding: 0px;\r\n  text-align: left;\r\n  line-height: 1.3;\r\n}\r\n\r\n.container_body .reg_complete p {\r\n  font-size: 13px;\r\n  padding-bottom: 15px;\r\n  line-height: 1.3;\r\n}\r\n\r\n.form_sec {\r\n  padding: 30px 40px 30px 40px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.form_sec_inner {\r\n  padding: 0px 10px 10px 10px;\r\n  border: 1px solid #3f3f3f;\r\n  border-radius: 20px;\r\n  margin: 5px 10px;\r\n  width: calc(50% - 40px) !important;\r\n  min-height: 540px;\r\n}\r\n\r\n.inner_part {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 49%;\r\n}\r\n\r\n.actionrequired {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  font-size: 14px;\r\n}\r\n\r\n.actionrequired a {\r\n  font-size: 14px;\r\n  padding: 0px 2px;\r\n  color: #294799;\r\n}\r\n\r\n.actionred h4 {\r\n  color: red;\r\n}\r\n\r\n.actionred p {\r\n  padding: 10px 0px;\r\n}\r\n\r\nform .form_sec .form_styl .inner_part {\r\n  font-size: 13px !important;\r\n  color: #294799 !important;\r\n  line-height: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.inner_part1 {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 24%;\r\n  border: 2px solid #ccc;\r\n  padding: 0px;\r\n}\r\n\r\n.inner_part2 {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n}\r\n\r\n.b_none {\r\n  border: none;\r\n  padding: 0px;\r\n}\r\n\r\n.mt-7 {\r\n  margin: 7px !important;\r\n}\r\n\r\n.inner_part label,\r\n.inner_part1 label,\r\n.inner_part2 label {\r\n  font-size: 13px;\r\n  padding-bottom: 5px;\r\n  font-weight: 600;\r\n  color: black;\r\n  display: flex;\r\n}\r\n\r\n.inner_part select {\r\n  padding: 7px;\r\n  border: 1px solid #bbbbbb;\r\n  border-radius: 4px;\r\n  margin: 0px;\r\n}\r\n\r\n.inner_part1 select,\r\n.inner_part2 select {\r\n  padding: 7px;\r\n  border: 1px solid #bbbbbb;\r\n  border-radius: 4px;\r\n  margin: 0px;\r\n}\r\n\r\n.inner_part input,\r\n.inner_part1 input,\r\n.inner_part2 input {\r\n  padding: 7px;\r\n  border: 1px solid #bbbbbb;\r\n  border-radius: 4px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.form_styl .inner_part input[type=\"radio\"] {\r\n  padding: 0px;\r\n  margin: 2px;\r\n  justify-content: center;\r\n  display: flex;\r\n  align-items: baseline;\r\n}\r\n\r\n.inner_part label,\r\n.inner_part1 label,\r\n.inner_part2 label {\r\n  padding-top: 10px;\r\n}\r\n\r\n.form_styl .inner_part span.flex:hover {\r\n  text-decoration: none;\r\n}\r\n\r\n.form_styl {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: baseline;\r\n}\r\n\r\n.form_styl.faqlist {\r\n  padding: 30px 0px 0px 0px;\r\n}\r\n\r\n.form_styl1 {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: self-start;\r\n  margin-top: 0px;\r\n}\r\n\r\n.w100 {\r\n  width: 100% !important;\r\n}\r\n\r\n.flex {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: baseline;\r\n}\r\n\r\nlabel.f_size {\r\n  font-size: 12px;\r\n  padding-left: 3px;\r\n}\r\n\r\n.banner_styl {\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.banner_styl img {\r\n  max-width: 100%;\r\n}\r\n\r\n.home_sec {\r\n  padding: 10px 20px 20px 20px;\r\n  border: 1px solid #d4d4d4;\r\n  border-radius: 10px;\r\n  margin-top: 0px;\r\n  width: 66% !important;\r\n}\r\n\r\n.home_app {\r\n  padding: 10px 0px 20px 0px;\r\n  border-radius: 10px;\r\n  margin-top: 3px;\r\n  width: 70% !important;\r\n}\r\n\r\n.form_styl h4 {\r\n  font-size: 18px;\r\n  margin: 0;\r\n  padding: 10px 0px;\r\n  color: #3e3e3e;\r\n  font-weight: normal;\r\n}\r\n\r\n.form_styl h4 span {\r\n  color: red;\r\n}\r\n\r\n.form_styl a,\r\np.top_head_styl,\r\n.form_sec .form_styl .inner_part p,\r\n.form_styl span {\r\n  font-size: 13px !important;\r\n  color: #294799 !important;\r\n  line-height: 20px;\r\n  cursor: auto;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  padding: 0;\r\n}\r\n\r\n.form_sec .form_styl .inner_part span p {\r\n  cursor: pointer;\r\n}\r\n\r\n.form_styl span.react-date-picker__inputGroup__leadingZero {\r\n  display: inline-block;\r\n  font: inherit;\r\n  color: black !important;\r\n  line-height: 0;\r\n  font-size: 13px !important;\r\n  font-weight: normal;\r\n}\r\n\r\n.react-date-picker--disabled span.react-date-picker__inputGroup__leadingZero {\r\n  color: #a1a1a1 !important;\r\n}\r\n\r\n.react-date-picker__button svg {\r\n  width: 16px;\r\n}\r\n\r\n.form_styl a:hover,\r\n.form_styl span:hover {\r\n  text-decoration: none;\r\n}\r\n.form_styl a.linkcheckegi:hover{\r\ntext-decoration: underline;\r\ncursor: pointer;\r\n}\r\n\r\n.home_app table tr th,\r\n.home_app table tr td {\r\n  text-align: left;\r\n  border-bottom: 1px solid #979696;\r\n  padding: 10px 0px;\r\n  font-size: 14px;\r\n  color: #4c4c4c;\r\n}\r\n\r\n.home_app table tr td a {\r\n  color: rgb(0 94 175);\r\n}\r\n\r\n.form_styl1 h4 {\r\n  margin: 0px 0px 5px 0px !important;\r\n  font-weight: 600;\r\n  line-height: 24px;\r\n  font-size: 18px;\r\n  border-bottom: 1px solid #ccc;\r\n  padding-bottom: 10px;\r\n}\r\n\r\nbutton.submit.btnClassSubmit {\r\n  margin: 0 15px;\r\n  background-color: #27409a;\r\n}\r\n\r\nbutton.submit.btnClassSubmit:hover {\r\n  background: #27409a;\r\n}\r\n\r\ninput.submit,\r\nbutton.submit {\r\n  background: #d52a10;\r\n  color: #fff;\r\n  width: auto;\r\n  margin: 0 auto;\r\n  margin-top: 20px;\r\n  outline: none;\r\n  font-size: 13px;\r\n  font-weight: 400;\r\n  padding: 7px 15px;\r\n  border: none;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n}\r\n\r\ninput.faq_submit {\r\n  background: #d52a10;\r\n  color: #fff;\r\n  width: 10%;\r\n  margin-top: 20px;\r\n  outline: none;\r\n  font-size: 13px;\r\n  font-weight: 400;\r\n  padding: 7px;\r\n  border: none;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n}\r\n\r\ninput:disabled,\r\nbutton.disabled,\r\n.disabled,\r\n.inner_part select:disabled,\r\n.inner_part2 select:disabled {\r\n  background: #eee;\r\n  border: 1px solid #ccc;\r\n  color: #a1a1a1;\r\n  cursor: no-drop;\r\n}\r\n\r\n.inner_part select:disabled.react-date-picker__inputGroup__input {\r\n  border: none;\r\n}\r\n\r\ninput.submit:hover,\r\nbutton.submit:hover {\r\n  background: #a6210c;\r\n}\r\n\r\n.ml_5 {\r\n  margin-left: 5px !important;\r\n}\r\n\r\n.sidebar {\r\n  height: 400px;\r\n  width: 21%;\r\n  margin-left: 0px;\r\n  padding-top: 20px;\r\n  background: #fff;\r\n  border-right: 2px solid #ccc;\r\n}\r\n\r\n.sidebar h4 {\r\n  font-size: 12px;\r\n  font-weight: normal;\r\n  padding: 3px 0px;\r\n  margin: 0;\r\n  text-align: center;\r\n}\r\n\r\n.sidebar ul {\r\n  margin: 0;\r\n  padding: 10px 0px;\r\n}\r\n\r\n.sidebar ul li {\r\n  font-size: 15px;\r\n  display: block;\r\n  line-height: 36px;\r\n  font-weight: normal;\r\n  padding: 8px 20px;\r\n}\r\n\r\n.sidebar ul li a {\r\n  font-size: 13px;\r\n  display: flex;\r\n  line-height: 21px;\r\n  font-weight: normal;\r\n  padding: 3px 5px;\r\n  text-decoration: none;\r\n  color: #000;\r\n  opacity: 0.8;\r\n  align-items: center;\r\n}\r\n\r\n.sidebar ul li.active {\r\n  background: #e7f3fd;\r\n  padding: 8px 18px;\r\n  border-left: 4px solid #d51e10;\r\n}\r\n\r\n.sidebar ul li.active a {\r\n  font-weight: 600;\r\n}\r\n\r\n.sidebar ul li:hover {\r\n  background: #e7f3fd;\r\n  border-left: 2px solid #d51e10;\r\n  padding: 8px 18px;\r\n  cursor: pointer;\r\n}\r\n\r\n.sidebar ul li i {\r\n  background: #008000;\r\n  padding: 7px;\r\n  border-radius: 50%;\r\n  color: #fff;\r\n  margin-right: 5px;\r\n  font-size: 12px;\r\n}\r\n\r\n.sidebar ul li span.pink i {\r\n  background: #fe617c;\r\n  padding: 7px;\r\n  border-radius: 50%;\r\n  color: #fff;\r\n  margin-right: 5px;\r\n  font-size: 12px;\r\n}\r\n\r\n.progressbar {\r\n  width: 90%;\r\n  background-color: #ddd;\r\n  border-radius: 10px;\r\n  margin: 5px 10px 0px 10px;\r\n}\r\n\r\n.scorebar {\r\n  text-align: right;\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n  color: white;\r\n}\r\n\r\n.sidebar .progress_clr {\r\n  width: 20% !important;\r\n  background-color: #04AA6D;\r\n  border-radius: 10px;\r\n  padding: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: .75rem;\r\n  font-size: 14px;\r\n}\r\n\r\n.right_panel {\r\n  padding: 10px 15px;\r\n  width: 79%;\r\n}\r\n\r\n.right_panel .scroll_styl {\r\n  max-height: 500px;\r\n  overflow-Y: scroll;\r\n  padding-right: 15px;\r\n  overflow-X: hidden;\r\n}\r\n\r\n.right_panel h4.panelhead {\r\n  font-size: 1.25rem;\r\n  margin: 0;\r\n  padding: 10px 0px;\r\n  color: #3e3e3e;\r\n}\r\n\r\n.form_sec .form_styl p {\r\n  font-size: 13px;\r\n  text-align: justify;\r\n  padding: 0px 0px 0px 0px;\r\n  color: #294799;\r\n  line-height: 20px;\r\n  padding-top: 10px;\r\n  font-weight: 700;\r\n  cursor: auto;\r\n}\r\n\r\n.form_sec .form_styl p a {\r\n  cursor: pointer;\r\n}\r\n\r\n.form_sec .form_styl .blctext {\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.form_sec .form_styl .blctext p {\r\n  font-size: 15px;\r\n  text-align: left;\r\n  padding: 0px 0px 0px 0px;\r\n  line-height: 1;\r\n  padding-top: 10px;\r\n  font-weight: 400;\r\n  color: #333333;\r\n}\r\n\r\n.footer_box h4 {\r\n  color: #fff;\r\n  display: block;\r\n  padding: 6px 0px;\r\n  margin: 0;\r\n  font-size: 16px;\r\n}\r\n\r\n.footer_box h4 img {\r\n  max-width: 18px;\r\n  vertical-align: bottom;\r\n}\r\n\r\nspan.earlyadmin p,\r\nspan.regularadmin p,\r\nspan.postearlyadmin p {\r\n  font-size: 13px !important;\r\n  color: red;\r\n  line-height: 1.3;\r\n  cursor: auto;\r\n  padding: 10px 0px;\r\n  display: inline;\r\n}\r\n\r\nspan.earlyadmin,\r\nspan.regularadmin,\r\nspan.postearlyadmin {\r\n  top: 7px;\r\n  position: relative;\r\n}\r\n\r\nspan.earlyadmin a,\r\nspan.regularadmin a,\r\nspan.postearlyadmin a {\r\n  color: rgb(0, 17, 94);\r\n  font-weight: 400;\r\n  font-size: 1p3x;\r\n}\r\n\r\nspan.earlyadmin p a,\r\nspan.regularadmin p a,\r\nspan.postearlyadmin p a {\r\n  color: #032d60;\r\n}\r\n\r\n.mt-3 {\r\n  margin-top: 30px;\r\n}\r\n\r\nspan.prvw {\r\n  padding: 10px 0px;\r\n  line-height: 3;\r\n}\r\n\r\n#programTool,\r\n#fedu,\r\n#medu,\r\n#orghelpTooltip,\r\n#exphelpTooltip,\r\n#famocc,\r\n#dob,\r\n#helpTooltip,\r\n#stateTooltip,\r\n#yearTooltip,\r\n#regionhelpTooltip,\r\n#class12helpTooltip,\r\n#areaTooltip,\r\n#domicileTooltip,\r\n#progPreference,\r\n#yearcompletion,\r\n#yearcompletionEdu,\r\n#typeoforg,\r\n#expoforg,\r\n#relevantwork,\r\n#programTooltip,\r\n#famin {\r\n  width: 235px;\r\n  background: #032d60;\r\n  cursor: pointer;\r\n  margin-left: 0px;\r\n  color: #fff !important;\r\n  padding: 5px;\r\n  opacity: 1;\r\n}\r\n\r\n.help_link #helpTooltip,\r\n#educationhelp {\r\n  width: 170px;\r\n  background: #032d60;\r\n  cursor: pointer;\r\n  margin-left: 0px;\r\n  color: #fff !important;\r\n  padding: 5px;\r\n  opacity: 1;\r\n}\r\n\r\n\r\n#programTool p,\r\n#famin p,\r\n#areaTooltip p,\r\n#dob p,\r\n#fedu p,\r\n#medu p,\r\n#domicileTooltip p,\r\n#famocc p,\r\n#helpTooltip p,\r\n#yearTooltip p,\r\n#regionhelpTooltip p,\r\n#stateTooltip p,\r\n#class12helpTooltip p,\r\n#orghelpTooltip p,\r\n#yearcompletion p,\r\n#yearcompletionEdu p,\r\n#progPreference p,\r\n#typeoforg p,\r\n#expoforg p,\r\n#relevantwork p,\r\n#exphelpTooltip p {\r\n  color: #fff !important;\r\n  font-size: 12px !important;\r\n  padding-top: 0px;\r\n  text-align: left;\r\n  font-weight: normal;\r\n  line-height: 1.3;\r\n}\r\n\r\n\r\n.inner_part label i,\r\n.form_styl table tr td i,\r\n.form_styl table tr th i,\r\n.right_panel span.help_link i {\r\n  cursor: pointer;\r\n  color: #747474;\r\n  margin: 3px;\r\n}\r\n.form_styl table tr td i{\r\n  color: #000;\r\n  margin: 3px;\r\n  cursor: auto !important;\r\n}\r\n.form_styl table th i{\r\n  color: #fff !important;\r\n}\r\n.inner_part label i:hover,\r\n.form_styl table tr td i:hover,\r\n.right_panel span.help_link i:hover {\r\n  cursor: pointer;\r\n  color: #a6170c;\r\n}\r\n\r\nspan.clender_styl i {\r\n  top: 0px;\r\n  position: absolute;\r\n  color: #032d60;\r\n  font-size: 16px;\r\n  padding: 7px 0px;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  right: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.clender_styl span.w100 {\r\n  padding: 0;\r\n  margin: 0;\r\n  position: relative;\r\n}\r\n\r\n.dflex {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: baseline;\r\n}\r\n\r\nspan.help_link {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\nspan.help_link p a {\r\n  color: #032d60;\r\n  text-decoration: none;\r\n  font-size: 14px;\r\n}\r\n\r\nspan.help_link p a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\nspan.help_link p a i {\r\n  color: #a6170c;\r\n}\r\n\r\n.blc_txt {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.container_body .form_styl .blc_txt p {\r\n  color: #000 !important;\r\n  font-weight: 600;\r\n  line-height: 12px;\r\n}\r\n\r\n.blc_txt p i {\r\n  color: #000;\r\n  font-weight: normal;\r\n}\r\n\r\n.right_panel .dflex h4.top_head,\r\n.right_panel .dflex h4,\r\n.right_panel .w100 h4.top_head {\r\n  color: #00f;\r\n  font-size: 18px;\r\n}\r\n\r\n.form_styl table th {\r\n  border: 1px solid #ccc;\r\n  margin: 0;\r\n  background: linear-gradient(to right, #2b308b, #2572a3);\r\n  border-radius: 5px;\r\n  width: 33%;\r\n  padding: 12px 10px;\r\n  color: #fff;\r\n}\r\n\r\n.form_styl table td {\r\n  border: 1px solid #ccc;\r\n  margin: 0;\r\n  width: 33.33%;\r\n  padding: 15px 10px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n.form_styl table td.previewPhotoupload{\r\n  width: 20%;\r\n}\r\n\r\n.form_styl table {\r\n  width: 100%;\r\n  border: 1px solid #ccc;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.form_styl table td input {\r\n  width: 96%;\r\n  padding: 4px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 2px;\r\n  height: 25px;\r\n}\r\n\r\n.form_styl table td select {\r\n  width: 96%;\r\n  padding: 4px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 2px;\r\n  height: 32px;\r\n}\r\n.ug_eduform .form_styl table td select,.ug_eduform .form_styl table td input{\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  height: 30px;\r\n}\r\n\r\n.form_styl table td.bottom_clr {\r\n  padding: 5px 10px;\r\n}\r\n\r\n.form_styl table td.bottom_clr:hover,\r\n.form_styl table tr:hover {\r\n  background: transparent;\r\n}\r\n\r\n.d_none {\r\n  display: none;\r\n}\r\n\r\n.login_box p,\r\n.error_shown {\r\n  color: red;\r\n  font-size: 13px;\r\n  line-height: 1.3;\r\n  font-weight: normal;\r\n}\r\n\r\n.w33 {\r\n  width: 33%;\r\n  padding: 0px 15px;\r\n}\r\n\r\n.w40 {\r\n  width: 40%;\r\n  padding: 0px 15px;\r\n}\r\n\r\n.w30 {\r\n  width: 30%;\r\n  padding: 0px 15px;\r\n}\r\n\r\n.w66 {\r\n  width: 66%;\r\n  padding: 0px 15px;\r\n}\r\n\r\n.uploadfile a {\r\n  padding: 7px 0px;\r\n  color: #294799;\r\n  font-size: 15px;\r\n  text-decoration: none;\r\n}\r\n\r\n.uploadfile a i {\r\n  margin-right: 5px;\r\n}\r\n\r\ntable {\r\n  font-size: 14px;\r\n}\r\n\r\n.form_styl1 table tr th,\r\n.form_styl1 table tr td {\r\n  text-align: left;\r\n  border-bottom: 1px solid #979696;\r\n  padding: 10px 6px;\r\n  font-size: 14px;\r\n  color: #4c4c4c;\r\n  width: 19%;\r\n  word-wrap: break-word;\r\n  max-width: 150px;\r\n}\r\n\r\n.container_body .faq .form_styl .raisequerydesc p {\r\n  font-size: 13px;\r\n  color: #a1a1a1;\r\n  overflow-wrap: break-word;\r\n  font-weight: normal;\r\n  border-bottom: 1px solid #bbbbbb;\r\n  padding: 0 0 3px;\r\n}\r\n\r\n.form_styl1 table tr th a,\r\n.form_styl1 table tr td a {\r\n  text-align: left;\r\n  padding: 10px 0px;\r\n  font-size: 14px;\r\n  color: #294799;\r\n}\r\n\r\n.form_styl1 .faq a {\r\n  font-size: 16px;\r\n  text-decoration: none;\r\n  color: #005fb2;\r\n  font-weight: 600;\r\n}\r\n\r\n.form_styl1 .faq a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.distance_learn a {\r\n  font-size: 14px;\r\n  color: #000;\r\n  line-height: 1.3;\r\n  cursor: pointer;\r\n}\r\n\r\n.distance_learn a:hover {\r\n  color: red;\r\n  text-decoration: underline;\r\n}\r\n\r\n.distance_learn a i {\r\n  margin-left: 4px;\r\n}\r\n\r\n.container_box .change_password p {\r\n  color: #000;\r\n  font-size: 13px;\r\n  line-height: 1.3;\r\n  text-align: left;\r\n  padding-top: 5px;\r\n}\r\n\r\n.container_box .change_password {\r\n  max-width: 300px;\r\n  min-height: 280px;\r\n  border-radius: 20px;\r\n  background: #fff;\r\n  margin: 20px auto;\r\n  padding: 15px 15px 5px 15px;\r\n  box-shadow: 3px 3px 10px #999;\r\n}\r\n\r\n\r\n.change_password .input_box {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n}\r\n\r\n.change_password .input_box label {\r\n  background: transparent;\r\n  padding: 10px 0px;\r\n  width: 100%;\r\n  text-align: left;\r\n  color: #000;\r\n  font-size: 14px;\r\n}\r\n\r\n.change_password input.button_styl {\r\n  background: #00115e;\r\n  color: #fff;\r\n  margin-top: 20px;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  border: none;\r\n  text-align: center;\r\n  max-width: 92%;\r\n  padding: 10px;\r\n}\r\n\r\n.change_password input {\r\n  border: 1px solid #ccc;\r\n  width: 100%;\r\n  outline: none;\r\n  max-width: 90%;\r\n}\r\n\r\n.change_password input[type=\"checkbox\"] {\r\n  border: 1px solid #ccc;\r\n  margin: 0px 5px;\r\n  width: 16px;\r\n  outline: none;\r\n  height: 16px;\r\n  accent-color: green;\r\n}\r\n\r\n.change_password label.green_txt {\r\n  color: green !important;\r\n}\r\n\r\n.change_password input[type=\"radio\"] {\r\n  border: 1px solid #ccc;\r\n  padding: 18px;\r\n  outline: none;\r\n  width: 20px;\r\n}\r\n\r\n.change_password span.radio_styl {\r\n  display: block;\r\n  position: relative;\r\n  padding-left: 30px;\r\n  margin-bottom: 10px;\r\n  cursor: pointer;\r\n  -webkit-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n.change_password .input_box span.radio_styl label {\r\n  background: transparent;\r\n  padding: 5px 0px;\r\n  width: 100%;\r\n  text-align: left;\r\n  color: #000;\r\n  font-weight: 600;\r\n  font-size: 12px;\r\n  margin: 0;\r\n}\r\n\r\n.container_box h4 {\r\n  text-align: center;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  margin: 0;\r\n  padding-top: 40px;\r\n}\r\n\r\n.container_box p {\r\n  text-align: center;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  margin: 0;\r\n  padding: 0px 0px 10px 0px;\r\n}\r\n\r\n.container_box .reset_password {\r\n  background: transparent !important;\r\n  margin: 0 auto !important;\r\n  min-height: 375px;\r\n  box-shadow: none;\r\n}\r\n\r\n.reset_password .input_box label i {\r\n  position: relative;\r\n  top: 40px;\r\n  color: #000;\r\n  left: 10px;\r\n}\r\n\r\n.reset_password input {\r\n  border: 1px solid #eee;\r\n  padding: 0px 0px 0px 30px;\r\n  width: 100%;\r\n  outline: none;\r\n}\r\n\r\n.reset_password input.button_styl {\r\n  background-color: red;\r\n}\r\n\r\n.reset_top h4 {\r\n  padding-top: 60px;\r\n}\r\n\r\n.reset_top p {\r\n  padding-top: 10px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.myImage {\r\n  width: 40%;\r\n  height: auto;\r\n  background-repeat: no-repeat;\r\n  background-size: 40%;\r\n  text-align: center;\r\n  box-shadow: 2px 2px 5px #999;\r\n}\r\n\r\n.text-center {\r\n  text-align: center !important;\r\n}\r\n\r\n.text-left {\r\n  text-align: left !important;\r\n}\r\n\r\ninput.Continue,\r\nbutton.Continue {\r\n  background: red;\r\n  color: #fff;\r\n  width: 12%;\r\n  margin: 0 auto;\r\n  margin-top: 20px;\r\n  outline: none;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  padding: 7px;\r\n  border: none;\r\n  cursor: pointer;\r\n  border-radius: 3px;\r\n}\r\n\r\n.faq h4 {\r\n  font-size: 16px;\r\n  padding: 0;\r\n  line-height: 24px;\r\n  border-bottom: 1.5px solid #727272;\r\n  padding-bottom: 5px;\r\n  font-weight: 600;\r\n}\r\n\r\n.faqlist h4 {\r\n  border-bottom: 1px solid #bbbbbb;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n.faq h3 {\r\n  border: none;\r\n  font-weight: 600;\r\n  font-size: 21px;\r\n  margin: 0;\r\n}\r\n\r\n.container_body .faq .form_styl p {\r\n  font-size: 11px;\r\n  color: #585858;\r\n  overflow-wrap: break-word;\r\n  font-weight: normal;\r\n}\r\n\r\n.container_body .faq .form_styl .faq_text p {\r\n  font-size: 13px;\r\n  padding: 3px 0px;\r\n}\r\n\r\n.container_body .faq .form_styl .faq_text p span {\r\n  color: #585858 !important;\r\n  font-weight: normal;\r\n  font-size: 13px !important;\r\n  text-align: left;\r\n  line-height: 1;\r\n  font-family: 'Lato', sans-serif;\r\n  ;\r\n}\r\n\r\n.container_body .faq .form_styl .faq_text p a span {\r\n  color: #294799 !important;\r\n  cursor: pointer;\r\n}\r\n\r\n.faq_text {\r\n  padding: 0px;\r\n  border-bottom: 1px solid #bbbbbb;\r\n  border-radius: 0px;\r\n  margin-bottom: 10px;\r\n  resize: none;\r\n  min-height: 35px;\r\n  height: auto;\r\n  font-size: 13px;\r\n  overflow: hidden;\r\n  cursor: none;\r\n}\r\n\r\n.container_body .faq .form_styl p a {\r\n  font-size: 13px !important;\r\n  color: #294799 !important;\r\n  padding: 0px;\r\n  cursor: pointer;\r\n  font-weight: normal;\r\n}\r\n\r\n.faq_tags {\r\n  padding: 20px 0px;\r\n  border-top: 1px solid #bbbbbb;\r\n  margin-top: 10px;\r\n}\r\n\r\n.faq_tags a {\r\n  color: #27599a;\r\n  border: 1px solid #27599a;\r\n  text-decoration: none;\r\n  padding: 5px 20px;\r\n  border-radius: 30px;\r\n  font-size: 12px !important;\r\n  font-weight: normal;\r\n  margin: 0px 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.commntbox {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  border: 1px solid #ccc;\r\n  padding: 5px 3px;\r\n  margin: 20px 0px 40px 0px;\r\n}\r\n\r\n.commntbox .w33 p {\r\n  padding: 3px 10px;\r\n}\r\n\r\n.commntbox a {\r\n  text-decoration: none;\r\n  font-size: 11px;\r\n}\r\n\r\n.commntbox i {\r\n  color: #7a7979;\r\n  border: 1px solid #ccc;\r\n  padding: 5px;\r\n}\r\n\r\n.faq .inner_part input {\r\n  padding: 7px;\r\n  border-bottom: 1px solid #bbbbbb;\r\n  border-radius: 0px;\r\n  margin-bottom: 10px;\r\n  border-top: none;\r\n  border-left: none;\r\n  border-right: none;\r\n}\r\n\r\n.faq .inner_part input:disabled {\r\n  background: transparent;\r\n  padding: 2px;\r\n}\r\n\r\n.clender_styl .react-date-picker__wrapper {\r\n  display: flex;\r\n  flex-grow: 1;\r\n  flex-shrink: 0;\r\n  border: thin solid #bbbbbb;\r\n  border-radius: 4px;\r\n  width: 100%;\r\n}\r\n\r\n.clender_styl .react-date-picker__inputGroup__input {\r\n  height: auto;\r\n  padding: 0 7px !important;\r\n  border: none !important;\r\n}\r\n\r\n.clender_styl .react-date-picker__inputGroup {\r\n  height: 29px;\r\n}\r\n\r\n.clender_styl .react-date-picker {\r\n  width: 100%;\r\n}\r\n\r\n.Toastify__toast--success {\r\n  background: #07bc0c;\r\n}\r\n\r\n.Toastify__toast--error {\r\n  background: #e74c3c;\r\n}\r\n\r\n.container_box .reset_email p {\r\n  color: #000;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  text-align: justify;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.container_box .reset_email h4 {\r\n  text-align: center;\r\n  font-size: 24px;\r\n  font-weight: 400;\r\n  width: 100%;\r\n  margin: 0;\r\n  padding: 10px 0px;\r\n}\r\n\r\n.container_box .reset_email a {\r\n  text-decoration: none;\r\n  color: #000f59;\r\n  padding: 15px 0px;\r\n  text-align: center;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n}\r\n\r\n.container_box .reset_email p span {\r\n  background: #fff;\r\n}\r\n\r\n.container_box .reset_email a:hover {\r\n  text-decoration: underline;\r\n  color: #000f59;\r\n}\r\n\r\n.text_red {\r\n  color: red;\r\n}\r\n\r\n.container_box .reset_email {\r\n  padding: 00px 0px;\r\n  flex-wrap: wrap;\r\n  align-content: center;\r\n  min-height: 100vh;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.container_box .reset_email .input_box {\r\n  max-width: 310px;\r\n  border-radius: 10px;\r\n  /* background: #fff; */\r\n  margin: 0 auto;\r\n  padding: 15px 15px 15px 15px;\r\n  /* box-shadow: 3px 3px 10px #999; */\r\n  text-align: center;\r\n}\r\n\r\n\r\n\r\n.Toastify__toast-theme--light p {\r\n  color: #fff;\r\n  font-size: 14px;\r\n  margin: 0;\r\n}\r\n\r\n.Toastify__toast-theme--light svg {\r\n  fill: #fff;\r\n}\r\n\r\n.Toastify__close-button svg {\r\n  border: 1px solid #fff;\r\n  padding: 3px;\r\n  fill: #fff;\r\n}\r\n\r\n.clender_styl .react-date-picker.error_msg {\r\n  outline: red;\r\n  border: 1.5px solid red;\r\n  margin-bottom: 0px;\r\n  border-radius: 5px;\r\n}\r\n\r\nspan.clender_styl {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.sharebox input.submit,\r\n.Commentbox input.submit {\r\n  float: right;\r\n}\r\n\r\n.Commentbox input.submit {\r\n  width: auto;\r\n  padding: 7px 10px;\r\n}\r\n\r\n.sharebox textarea {\r\n  padding: 10px;\r\n  width: 97%;\r\n  font-family: 'Lato', sans-serif;\r\n  resize: vertical;\r\n}\r\n\r\na.attchfile,\r\nspan.attchfile {\r\n  background: #999;\r\n  color: #fff;\r\n  margin: 0 auto;\r\n  outline: none;\r\n  font-size: 15px;\r\n  font-weight: 400;\r\n  padding: 7px;\r\n  border: none;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  top: 25px;\r\n  position: relative;\r\n}\r\n\r\n.form_styl .sharebox h4 {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.m_auto {\r\n  margin: 0 auto;\r\n}\r\n\r\n.sharechat img,\r\n.sharechat i {\r\n  border-radius: 50%;\r\n  padding: 7px;\r\n  width: 16px;\r\n  height: 16px;\r\n  background: #8199af;\r\n  font-size: 14px;\r\n  text-align: center;\r\n  color: #fff;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.sharechat {\r\n  display: flex;\r\n  padding: 15px 10px;\r\n  width: 100%;\r\n  background: #fff;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.container_body .form_styl .sharechat p {\r\n  color: #3c3c3c;\r\n  padding: 0px 15px;\r\n  font-weight: normal;\r\n  line-height: 1.3;\r\n}\r\n\r\n.container_body .form_styl .sharechat a {\r\n  font-weight: normal;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n}\r\n\r\n.sharechatinner {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: flex-start;\r\n  border: 1px solid #ccc;\r\n  margin: 20px 7px 10px 60px;\r\n  padding: 10px;\r\n  width: 100%;\r\n}\r\n\r\n.subchatbox {\r\n  background: #eee;\r\n  /* padding: 10px 5px;    */\r\n}\r\n\r\n.container_body .comentpart p {\r\n  /* padding: 6px 5px;\r\n  background: #fff;\r\n  border-radius: 5px;\r\n  width: 97%;\r\n  min-height: 40px;\r\n  word-break: break-all;\r\n  border: 1px solid #dadada; */\r\n  padding-left: 0;\r\n  border: 0;\r\n  color: red;\r\n}\r\n\r\n.sharecomment {\r\n  border: 1px solid #ccc;\r\n  padding: 10px 15px;\r\n  background: #f3f3f3;\r\n  margin: 20px 0px;\r\n}\r\n\r\n.comentpart {\r\n  padding: 10px 0px;\r\n  width: 100%;\r\n}\r\n\r\n.comentpartfull {\r\n  padding: 0px;\r\n  width: 100%;\r\n}\r\n\r\n.comentpart textarea {\r\n  width: 100%;\r\n  font-size: 13px;\r\n  padding: 5px;\r\n  border: 1px solid #ccc;\r\n  font-family: 'Lato', sans-serif;\r\n}\r\n\r\n.comentpart span.comntbtn {\r\n  padding-left: 12px;\r\n  min-width: 15%;\r\n  text-align: center;\r\n}\r\n\r\n.comentpart span {\r\n  padding: 0px;\r\n  text-align: center;\r\n}\r\n\r\n.comentpart span i {\r\n  background: #c1e3e7;\r\n  padding: 10px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.replycommnt {\r\n  width: 100%;\r\n  padding: 15px 0px 10px 0px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n}\r\n\r\n.replycommntleft {\r\n  width: 100%;\r\n  padding: 15px 60px 10px 0px;\r\n}\r\n\r\n.replycommntfull {\r\n  width: 100%;\r\n  padding: 15px 0px 10px 0px;\r\n}\r\n\r\n.sharecomment .comentpart span p {\r\n  padding: 6px 5px;\r\n  background: #c1e3e7;\r\n  border-radius: 10px;\r\n  margin-top: 5px;\r\n  font-weight: 600;\r\n  min-height: auto;\r\n  cursor: pointer;\r\n}\r\n\r\n.sharecomment .comentpart span p i {\r\n  padding: 0px 4px;\r\n}\r\n\r\n.container_body .commentParrts p.datetimecomment {\r\n  padding: 5px 0;\r\n\r\n  color: #00000099;\r\n  font-size: 14px;\r\n}\r\n\r\n.commentParrts {\r\n  padding-left: 14px;\r\n}\r\n\r\n.sharechat p.rcorners1 {\r\n  font-size: 15px;\r\n  line-height: 1.5;\r\n  font-weight: 400 !important;\r\n  color: #005fb2;\r\n  display: inline-block;\r\n  border-bottom: 1px dotted #ccc;\r\n  padding: 0px !important;\r\n  word-break: break-word;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.sharechat p.rcorners2 {\r\n  color: red;\r\n  font-size: 14px;\r\n  padding: 0;\r\n  border-bottom: 0;\r\n  word-break: break-all;\r\n  line-height: 1.5;\r\n}\r\n\r\n.sharechat p.rcorners2 p {\r\n  padding: 0;\r\n}\r\n\r\n.sharechat p a {\r\n  font-size: 13px;\r\n  color: #337ab7;\r\n  font-weight: 600;\r\n}\r\n\r\n.inner_part textarea {\r\n  padding: 7px;\r\n  border: 1px solid #bbbbbb;\r\n  border-radius: 4px;\r\n  margin-bottom: 10px;\r\n  resize: vertical;\r\n  font-family: 'Lato', sans-serif;\r\n}\r\n\r\n.faq .form_styl .inner_part textarea {\r\n  padding: 7px;\r\n  border-bottom: 1px solid #bbbbbb;\r\n  border-radius: 0px;\r\n  margin-bottom: 10px;\r\n  resize: none;\r\n  min-height: 45px;\r\n  height: auto;\r\n  font-size: 12px;\r\n  /* border-top: none;\r\n  border-left: none;\r\n  border-right: none; */\r\n}\r\n\r\n.inner_part textarea:disabled,\r\n.faq .form_styl .inner_part textarea:disabled {\r\n  background: #eee;\r\n  border-bottom: 1px solid #ccc;\r\n}\r\n\r\n\r\n.inner_part i.iconstyl {\r\n  display: block;\r\n  position: relative;\r\n  left: 365px;\r\n  top: -32px;\r\n  font-size: 13px;\r\n  color: #666;\r\n  cursor: auto;\r\n}\r\n\r\n/* .change_password \r\n input[type=\"checkbox\"] {\r\n    border: 1px solid #ccc;\r\n    padding: 10px;\r\n    width: 6%;\r\n    background: green;\r\n    color: #fff;\r\n} */\r\n.error_text {\r\n  position: relative;\r\n  right: 10px;\r\n  float: right;\r\n  display: block;\r\n  text-align: right;\r\n  top: -27px;\r\n}\r\n\r\n.w100.innercomment {\r\n  margin-top: 10px;\r\n}\r\n\r\n.dropdown {\r\n  display: block;\r\n  background: #fff;\r\n  border-radius: 7px;\r\n  margin: 0;\r\n  padding: 0;\r\n  position: absolute;\r\n  border: 1px solid #eee;\r\n  box-shadow: 0px 2px 5px #5a5a5a;\r\n  margin-left: 25px;\r\n}\r\n\r\n.dropdown::before {\r\n  content: '';\r\n  position: absolute;\r\n  border: 10px solid transparent;\r\n  border-bottom: 10px solid #fff;\r\n  top: -20px;\r\n  left: 7px;\r\n}\r\n\r\n.dropdown ul {\r\n  padding: 0;\r\n  margin: 0;\r\n  width: 140px;\r\n}\r\n\r\n.dropdown ul li {\r\n  list-style: none;\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n  padding: 5px 10px;\r\n  cursor: pointer;\r\n  color: #000f59;\r\n}\r\n\r\n.dropdown ul li a {\r\n  list-style: none;\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n  cursor: pointer;\r\n  color: #000f59;\r\n}\r\n\r\n.dropdown ul li i {\r\n  font-size: 12px;\r\n  color: #000f59;\r\n  vertical-align: baseline;\r\n  padding-right: 3px;\r\n}\r\n\r\n.dropdown ul li:hover {\r\n  background: #eee;\r\n  border-radius: 7px;\r\n}\r\n\r\n.password-good-color {\r\n  color: green;\r\n}\r\n\r\n.password-message {\r\n  display: block;\r\n  line-height: 45px;\r\n  font-size: 10px;\r\n  padding: 0 10px;\r\n  pointer-events: none;\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n}\r\n\r\n.addnewrecord {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.addnewrecord a,\r\n.addnewrecord span {\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  color: #27599a;\r\n  margin-left: 15px;\r\n  background: #eee;\r\n  padding: 2px 5px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.addnewrecord a:hover,\r\n.addnewrecord span:hover {\r\n  background: #27599a;\r\n  color: #fff !important;\r\n  text-decoration: none;\r\n}\r\n\r\n.removerecord {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.removerecord a,\r\n.removerecord span {\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  color: red;\r\n  margin-left: 15px;\r\n  background: #eee;\r\n  padding: 2px 5px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.removerecord a:hover,\r\n.removerecord span:hover {\r\n  background: red;\r\n  color: #fff;\r\n}\r\n\r\n.orgstyl {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  background: #eee;\r\n  padding: 0px 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.orgstyl h4 {\r\n  margin: 0;\r\n  padding: 10px 0px;\r\n  font-size: 16px;\r\n}\r\n\r\nspan.worklocation {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  flex-direction: column;\r\n}\r\n\r\nspan.worklocation input[type=\"text\"] {\r\n  width: 90%;\r\n  border: 1px solid #bbbbbb;\r\n  border-radius: 4px;\r\n  padding: 7px 5px;\r\n}\r\n\r\nspan.worklocation label {\r\n  color: black;\r\n}\r\n\r\n.inner_part3 {\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 49%;\r\n}\r\n\r\n.form_part {\r\n  padding-top: 10px;\r\n  padding-bottom: 100px;\r\n}\r\n\r\n.blctext b {\r\n  line-height: 1.6;\r\n}\r\n\r\n.blctext h2 {\r\n  margin: 0;\r\n  padding: 5px 0px;\r\n  font-size: 25px;\r\n  font-weight: 700;\r\n}\r\n\r\n.heading_styl h4 {\r\n  color: #fff;\r\n  padding: 10px;\r\n  /* font-size: 1.125rem; */\r\n}\r\n\r\nbutton:disabled,\r\nbutton {\r\n  padding: 10px;\r\n  margin-top: 10px;\r\n}\r\n\r\nbutton:disabled.react-date-picker__button {\r\n  padding: 7px;\r\n  margin-top: 0px;\r\n}\r\n\r\n.error_green {\r\n  color: green;\r\n  font-size: 13px;\r\n  line-height: 1.3;\r\n  font-weight: normal;\r\n}\r\n\r\n\r\n\r\n/* ----- Create a custom checkbox ---- */\r\n.input_box .radio_styl input {\r\n  position: absolute;\r\n  opacity: 0;\r\n  cursor: pointer;\r\n  height: 0;\r\n  width: 0;\r\n}\r\n\r\n.input_box span.radio_styl .checkmark {\r\n  position: absolute;\r\n  top: 3px;\r\n  left: 0;\r\n  height: 18px;\r\n  width: 18px;\r\n  background-color: #eee;\r\n  border-radius: 30px;\r\n  border: 1px solid #ccc;\r\n}\r\n\r\nspan.radio_styl input:hover input~.checkmark {\r\n  background-color: #ccc;\r\n}\r\n\r\nspan.radio_styl input:checked~.checkmark {\r\n  background-color: green;\r\n}\r\n\r\nspan.radio_styl .checkmark:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  display: none;\r\n}\r\n\r\nspan.radio_styl input:checked~.checkmark:after {\r\n  display: block;\r\n}\r\n\r\nspan.radio_styl .checkmark:after {\r\n  left: 5px;\r\n  top: 2px;\r\n  width: 6px;\r\n  height: 10px;\r\n  border: solid white;\r\n  border-width: 0 3px 3px 0;\r\n  transform: rotate(45deg);\r\n}\r\n\r\n/* ----- End Create a custom checkbox ---- */\r\n\r\n\r\n.form_styl ul {\r\n  margin: 0;\r\n  padding: 20px;\r\n}\r\n\r\n.form_styl ul li {\r\n  list-style: none;\r\n  color: black;\r\n  font-weight: normal;\r\n  line-height: 1.5;\r\n}\r\n\r\n.form_sec .form_styl .paymentsyl p {\r\n  font-size: 13px;\r\n  text-align: justify;\r\n  padding: 0px 0px 0px 0px;\r\n  color: #000 !important;\r\n  line-height: 20px;\r\n  padding-top: 10px;\r\n  font-weight: 400;\r\n  cursor: auto;\r\n}\r\n\r\n.form_sec .form_styl .paymentsyl ul li {\r\n  font-size: 13px;\r\n  text-align: justify;\r\n  padding: 0px 0px 5px 0px;\r\n  color: #000;\r\n  line-height: 1.4;\r\n  font-weight: 400;\r\n  cursor: auto;\r\n  list-style: initial;\r\n}\r\n\r\n.form_sec .form_styl .paymentsyl ul li:first-child {\r\n  list-style: none;\r\n  margin-left: -18px;\r\n}\r\n\r\n.form_sec .form_styl .paymentsyl strong.red {\r\n  color: red;\r\n}\r\n\r\n.form_sec .form_styl .paymentsyl ul li input {\r\n  border: 1px solid #bbbbbb;\r\n  border-radius: 4px;\r\n  vertical-align: bottom;\r\n  margin-bottom: 3px;\r\n  padding: 0;\r\n  margin-left: 0;\r\n}\r\n\r\n.form_styl .inner_part p {\r\n  color: black;\r\n  padding: 10px 0px;\r\n}\r\n\r\n\r\n\r\n\r\n.checkbox_styl {\r\n  padding: 0px;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n}\r\n\r\n.scroll_styl .heading_styl.head_font h4,\r\n.container_body .heading_styl.head_font h4 {\r\n  font-size: 18px;\r\n}\r\n\r\n.blc_txt span {\r\n  color: black !important;\r\n  font-weight: normal;\r\n  cursor: auto;\r\n}\r\n\r\n.blc_txt span:hover {\r\n  text-decoration: none;\r\n  cursor: auto;\r\n}\r\n\r\n\r\n.w100.innercomment textarea {\r\n  width: 640px;\r\n  margin-left: 15px;\r\n  border: 1px solid #ccc;\r\n  padding: 5px;\r\n}\r\n\r\n.inner_part input.react-date-picker__inputGroup__input {\r\n  margin: 6px 0px 0px 0px;\r\n  height: 15px;\r\n  border: none !important;\r\n  padding: 0;\r\n  font-size: 13px;\r\n  font-weight: 400;\r\n  color: black;\r\n}\r\n\r\n.inner_part input.react-date-picker__inputGroup__input:disabled {\r\n  color: #a1a1a1;\r\n}\r\n\r\n.react-date-picker__wrapper {\r\n  height: 34px;\r\n  border: 1px solid #bbbbbb;\r\n  border-radius: 3px;\r\n}\r\n\r\n.react-date-picker__inputGroup {\r\n  padding: 3px 7px;\r\n}\r\n\r\n.react-date-picker__button {\r\n  margin: 0;\r\n}\r\n\r\n.dashboard_note {\r\n  background: #eee;\r\n  padding: 10px;\r\n  width: 96%;\r\n  margin: 0px 30px;\r\n}\r\n\r\n.dashboard_note p {\r\n  margin: 0;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  color: #294799;\r\n  line-height: 1.5;\r\n}\r\n\r\n.container_body.signinredrct {\r\n  /* border: 1px solid #c3d6e3; */\r\n  min-height: 500px;\r\n  margin: 45px auto;\r\n  /* background: rgb(244 244 244 / 85%); */\r\n  padding: 30px 10px;\r\n  max-width: 1020px;\r\n  margin: 0 auto;\r\n  margin-top: 40px;\r\n  text-align: center;\r\n}\r\n\r\n.signinredrct button.submit {\r\n  max-width: 12%;\r\n}\r\n\r\n.sharebtm {\r\n  display: flex;\r\n  align-items: baseline;\r\n  width: 100%;\r\n  justify-content: space-between;\r\n  flex-direction: row;\r\n}\r\n\r\n.signin_head {\r\n  max-width: 330px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.signin_head h4 {\r\n  font-size: 24px;\r\n  color: rgba(0, 0, 0, 0.8);\r\n  font-weight: 600;\r\n  padding-top: 30px;\r\n  line-height: 1.5;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.container_box .signin_head p {\r\n  line-height: 1.4;\r\n  padding-top: 5px;\r\n  color: #666;\r\n  font-size: 16px;\r\n  padding-bottom: 0;\r\n}\r\n\r\n\r\nselect.react-date-picker__inputGroup__input {\r\n  padding: 0;\r\n  border: none;\r\n  appearance: none;\r\n  min-width: 20px;\r\n  font-size: 13px;\r\n  color: black;\r\n  font-weight: 400;\r\n}\r\n\r\n\r\n.container_body .sidebar p {\r\n  color: red;\r\n  text-align: left;\r\n  padding-top: 5px;\r\n}\r\n\r\na.regagain {\r\n  padding-top: 25px;\r\n  display: block;\r\n  cursor: pointer;\r\n  max-width: 15%;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n}\r\n\r\n.uploadpic {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.uploadpic span {\r\n  padding-top: 3px;\r\n}\r\n\r\n.uploaddoc span.uploadfile,\r\n.uploadpic span.uploadfile {\r\n  padding: 5px 0px;\r\n  color: #EA001c !important;\r\n  cursor: pointer;\r\n}\r\n\r\n.form_styl .uploadpic span.uploadfile_styl {\r\n  padding: 3px 10px;\r\n  color: #000 !important;\r\n  cursor: pointer;\r\n  background: #eee;\r\n  border: 1px solid #ccc;\r\n}\r\n\r\n.uploaddoc span.uploadfile i {\r\n  padding-right: 2px;\r\n}\r\n\r\n.uploaddoc span {\r\n  padding: 0px 5px;\r\n}\r\n\r\n.react-date-picker__clear-button {\r\n  position: absolute;\r\n  right: 32px;\r\n  top: -3px;\r\n  width: 25px;\r\n  height: 25px;\r\n\r\n}\r\n\r\n.react-date-picker__clear-button:before,\r\n.react-date-picker__clear-button:after {\r\n  position: absolute;\r\n  left: 15px;\r\n  content: ' ';\r\n  height: 15px;\r\n  width: 2px;\r\n  background-color: #333;\r\n}\r\n\r\n.react-date-picker__clear-button:before {\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.react-date-picker__clear-button:after {\r\n  transform: rotate(-45deg);\r\n}\r\n\r\n/* .rs-loader .rs-loader-spin, .rs-loader .rs-loader-spin:after, .rs-loader .rs-loader-spin:before {\r\n  height: 18px;\r\n  width: 18px;\r\n}\r\n\r\n.rs-loader-speed-normal .rs-loader-spin:after {\r\n  -webkit-animation-duration: .6s;\r\n  animation-duration: .6s;\r\n} */\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* HTML: <div class=\"loader\"></div> */\r\n/* .loaderstyl {\r\n  border: 7px solid #f3f3f3;\r\n  border-radius: 50%;\r\n  border-top: 7px solid #132fbd;\r\n  width: 50px;\r\n  height: 50px;\r\n  animation: spin 2s linear infinite;\r\n \r\n  animation: spin 2s linear infinite;\r\n} */\r\n\r\n/* HTML: <div class=\"loader\"></div> */\r\n\r\n/* .loader_back{\r\n  position: \"fixed\";\r\n  top: 0;\r\n                left: 0;\r\n                width: 100%;\r\n                height: 100%;\r\n                background: rgba(0, 0, 0, 0.5);\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                z-index: 2;\r\n                backdrop-filter: blur(8px);\r\n} */\r\n\r\n.loaderstyl {\r\n  width: 60px;\r\n  aspect-ratio: 2;\r\n  --_g: no-repeat radial-gradient(farthest-side, #000 90%, #0000);\r\n  background:\r\n    var(--_g) 0 50%,\r\n    var(--_g) 50% 50%,\r\n    var(--_g) 50% 50%,\r\n    var(--_g) 100% 50%;\r\n  background-size: 25% 50%;\r\n  animation: l12 1s infinite linear;\r\n}\r\n\r\n/* payment loader*/\r\n\r\n\r\n\r\n@keyframes l12 {\r\n  33% {\r\n    background-position: 0 0, 50% 100%, 50% 100%, 100% 0\r\n  }\r\n\r\n  66% {\r\n    background-position: 50% 0, 0 100%, 100% 100%, 50% 0\r\n  }\r\n\r\n  100% {\r\n    background-position: 50% 50%, 0 50%, 100% 50%, 50% 50%\r\n  }\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* HTML: <div class=\"loader\"></div> */\r\n/* HTML: <div class=\"loader\"></div> */\r\n.loader {\r\n  --s: 28px;\r\n  height: var(--s);\r\n  aspect-ratio: 2.5;\r\n  --_g: #000 90%, #0000;\r\n  --_g0: no-repeat radial-gradient(farthest-side, var(--_g));\r\n  --_g1: no-repeat radial-gradient(farthest-side at top, var(--_g));\r\n  --_g2: no-repeat radial-gradient(farthest-side at bottom, var(--_g));\r\n  background: var(--_g0), var(--_g1), var(--_g2), var(--_g0), var(--_g1), var(--_g2);\r\n  background-size: 20% 50%, 20% 25%, 20% 25%;\r\n  animation: l45 1s infinite;\r\n}\r\n\r\n@keyframes l45 {\r\n  0% {\r\n    background-position: calc(0*100%/3) 50%, calc(1*100%/3) calc(50% + calc(var(--s)/8)), calc(1*100%/3) calc(50% - calc(var(--s)/8)), calc(3*100%/3) 50%, calc(2*100%/3) calc(50% + calc(var(--s)/8)), calc(2*100%/3) calc(50% - calc(var(--s)/8))\r\n  }\r\n\r\n  33% {\r\n    background-position: calc(0*100%/3) 50%, calc(1*100%/3) 100%, calc(1*100%/3) 0, calc(3*100%/3) 50%, calc(2*100%/3) 100%, calc(2*100%/3) 0\r\n  }\r\n\r\n  66% {\r\n    background-position: calc(1*100%/3) 50%, calc(0*100%/3) 100%, calc(0*100%/3) 0, calc(2*100%/3) 50%, calc(3*100%/3) 100%, calc(3*100%/3) 0\r\n  }\r\n\r\n  90%,\r\n  100% {\r\n    background-position: calc(1*100%/3) 50%, calc(0*100%/3) calc(50% + calc(var(--s)/8)), calc(0*100%/3) calc(50% - calc(var(--s)/8)), calc(2*100%/3) 50%, calc(3*100%/3) calc(50% + calc(var(--s)/8)), calc(3*100%/3) calc(50% - calc(var(--s)/8))\r\n  }\r\n}\r\n\r\n.loader-content {\r\n  width: auto !important;\r\n  margin: auto !important;\r\n  border-radius: 9.3rem !important;\r\n}\r\n\r\nspan.clender_styl input {\r\n  padding: 7px;\r\n  border: 1px solid #bbbbbb;\r\n  border-radius: 4px;\r\n  margin-bottom: 10px;\r\n  width: 97%;\r\n}\r\n\r\n.main_container.login_main_container .container_box {\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n@media screen and (min-width: 1921px) and (max-width: 4720px) {\r\n\r\n  .container_body .home_sec,\r\n  .container_body .home_app {\r\n    width: 100% !important;\r\n  }\r\n\r\n  .footer_box {\r\n    width: 95%;\r\n  }\r\n\r\n  /* .container_box { \r\n    min-height: 100%;\r\n  } */\r\n}\r\n\r\n\r\n@media screen and (min-width: 1201px) and (max-width: 1250px) {\r\n  .container_body {\r\n    max-width: 1145px;\r\n  }\r\n\r\n  .top_header {\r\n    max-width: 1145px;\r\n  }\r\n\r\n  .menu_header {\r\n    max-width: 1145px;\r\n  }\r\n\r\n  .container_box {\r\n    min-height: 100%;\r\n  }\r\n\r\n}\r\n\r\n@media screen and (min-width: 1300px) and (max-width: 1420px) {\r\n  .container_body {\r\n    max-width: 1280px;\r\n  }\r\n\r\n  .top_header {\r\n    max-width: 1280px;\r\n  }\r\n\r\n  .menu_header {\r\n    max-width: 1280px;\r\n  }\r\n\r\n}\r\n\r\n@media screen and (min-width: 1421px) and (max-width: 1720px) {\r\n  .container_body {\r\n    max-width: 1380px;\r\n  }\r\n\r\n  .top_header {\r\n    max-width: 1380px;\r\n  }\r\n\r\n  .menu_header {\r\n    max-width: 1380px;\r\n  }\r\n\r\n  .container_body .home_sec,\r\n  .container_body .home_app {\r\n    width: 100% !important;\r\n  }\r\n\r\n  /* .container_box{\r\n    min-height: 100%;\r\n  } */\r\n  /* .main_container .container_box {\r\n    min-height: 100%;\r\n} */\r\n}\r\n\r\n\r\n@media screen and (min-width: 1721px) and (max-width: 1920px) {\r\n  .container_body {\r\n    max-width: 1680px;\r\n  }\r\n\r\n  .top_header {\r\n    max-width: 1680px;\r\n  }\r\n\r\n  .menu_header {\r\n    max-width: 1680px;\r\n  }\r\n\r\n  .right_panel .scroll_styl {\r\n    max-height: 600px;\r\n  }\r\n\r\n}\r\n\r\n\r\n@media (max-width: 1023px) {\r\n  .sidebar {\r\n    width: 35%;\r\n    border: none;\r\n  }\r\n\r\n  .container_body {\r\n    padding: 10px 5px;\r\n  }\r\n\r\n  .sidebar ul {\r\n    margin: 0;\r\n    padding: 10px 5px 0px 5px;\r\n  }\r\n\r\n  .sidebar ul li.active {\r\n    padding: 7px 2px;\r\n  }\r\n\r\n  .sidebar ul li a {\r\n    font-size: 13px;\r\n    padding: 7px 2px;\r\n    display: flex;\r\n    line-height: 1.5;\r\n  }\r\n\r\n  .right_panel {\r\n    padding: 10px 10px;\r\n    width: 65%;\r\n  }\r\n\r\n  .user_profile {\r\n    width: 55%;\r\n  }\r\n\r\n  .sidebar ul li {\r\n    padding: 2px 6px;\r\n  }\r\n\r\n  .sidebar ul li.active {\r\n    padding: 7px 2px;\r\n  }\r\n\r\n  .sidebar ul li a {\r\n    font-size: 14px;\r\n    padding: 7px 2px;\r\n    display: flex;\r\n    line-height: 1.5;\r\n  }\r\n\r\n  .right_panel {\r\n    padding: 10px 10px;\r\n    width: 65%;\r\n  }\r\n\r\n  .user_profile {\r\n    width: 100%;\r\n  }\r\n\r\n  .sidebar ul li {\r\n    padding: 2px 6px;\r\n  }\r\n\r\n  .right_panel .scroll_styl {\r\n    overflow-y: auto;\r\n    max-height: 100%;\r\n  }\r\n\r\n  .form_part .form_styl .inner_part1 .heading_styl h4,\r\n  .form_styl .heading_styl h4,\r\n  .heading_styl h4 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .form_sec {\r\n    padding: 10px 10px 20px 10px;\r\n  }\r\n\r\n  input.submit,\r\n  button.submit {\r\n    width: 35%;\r\n  }\r\n\r\n  .sharebox textarea {\r\n    padding: 5px;\r\n    max-width: 98%;\r\n    resize: none;\r\n  }\r\n\r\n  .w66 {\r\n    padding: 0px 5px;\r\n  }\r\n\r\n  .w33 {\r\n    width: 30%;\r\n    padding: 0px 7px;\r\n  }\r\n\r\n  .comentpart span {\r\n    min-width: 20%;\r\n  }\r\n\r\n  .container_body .comentpart p {\r\n    width: 76%;\r\n  }\r\n\r\n  .logostyl img {\r\n    max-width: 130px;\r\n    padding: 3px 0px 0px 9px;\r\n  }\r\n\r\n  .form_styl.Work_experience {\r\n    align-items: end;\r\n  }\r\n}\r\n\r\n\r\n@media (max-width: 576px) {\r\n  .container_box .login_box {\r\n    max-width: 240px;\r\n    min-height: 285px;\r\n  }\r\n\r\n  .container_box .signup_box {\r\n    max-width: 240px;\r\n    min-height: 425px;\r\n    padding: 20px 20px 15px 20px;\r\n  }\r\n\r\n  .form_sec {\r\n    width: 100% !important;\r\n    padding: 10px 7px 20px 7px;\r\n  }\r\n\r\n  .form_styl {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .inner_part,\r\n  .inner_part1 {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n  }\r\n\r\n  .inner_part select {\r\n    width: 97%;\r\n  }\r\n\r\n  .inner_part input,\r\n  .inner_part1 input,\r\n  .inner_part2 input {\r\n    width: 96%;\r\n  }\r\n\r\n  .form_sec_inner {\r\n    width: 90% !important;\r\n    padding: 0px 10px 10px 10px;\r\n  }\r\n\r\n  .user_profile {\r\n    width: 100%;\r\n  }\r\n\r\n  .profile_box {\r\n    width: 100%;\r\n  }\r\n\r\n  .nav_link {\r\n    width: 100%;\r\n  }\r\n\r\n  .home_sec {\r\n    width: 86% !important;\r\n  }\r\n\r\n  .home_app {\r\n    width: 98% !important;\r\n  }\r\n\r\n  .container_body.flex {\r\n    flex-direction: column;\r\n    width: 95%;\r\n    padding: 10px 0px;\r\n  }\r\n\r\n  .sidebar {\r\n    width: 100%;\r\n    border: none;\r\n    height: auto;\r\n  }\r\n\r\n  .right_panel {\r\n    padding: 10px 0px;\r\n    width: 100%;\r\n  }\r\n\r\n  .right_panel .scroll_styl {\r\n    overflow-y: auto;\r\n    max-height: 100%;\r\n    padding-right: 0px;\r\n  }\r\n\r\n  input.submit,\r\n  button.submit {\r\n    width: 40%;\r\n  }\r\n\r\n  .w33 {\r\n    width: 100%;\r\n    padding: 0px;\r\n  }\r\n\r\n  .w66 {\r\n    padding: 0px;\r\n    width: 100%;\r\n  }\r\n\r\n  .sharechatinner {\r\n    width: 85%;\r\n    margin: 15px 0px 0px 42px;\r\n  }\r\n\r\n  .comentpart span {\r\n    min-width: 21%;\r\n  }\r\n\r\n  .container_body .comentpart p {\r\n    width: 75%;\r\n  }\r\n\r\n  .main_part {\r\n    width: 95%;\r\n    max-width: 100%;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .progressbar {\r\n    width: 100%;\r\n    margin: 0px;\r\n  }\r\n\r\n  .right_panel .dflex h4.top_head,\r\n  .right_panel .dflex h4,\r\n  .right_panel .w100 h4.top_head {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .container_body p {\r\n    font-size: 12px;\r\n    padding: 0px 0px;\r\n  }\r\n\r\n  span.help_link p a {\r\n    font-size: 12px;\r\n  }\r\n\r\n\r\n}\r\n\r\n.txt {\r\n  border-style: none;\r\n  border-color: Transparent;\r\n  overflow: auto;\r\n}\r\n\r\n.form_styl a.cButton {\r\n  display: block;\r\n  width: 115px;\r\n  background: red;\r\n  padding: 3px 5px;\r\n  text-align: center;\r\n  border-radius: 5px;\r\n  color: white;\r\n  font-weight: bold;\r\n  margin-top: 10px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  margin: 0 auto;\r\n}\r\n\r\n.form_styl a.cButton:hover {\r\n  text-decoration: none;\r\n}\r\n\r\n.rcorners1 {\r\n  /* border-radius: 10px;\r\n  border: 0.2px solid #8da1cd; */\r\n  /* padding: 20px;\r\n  width: 200px;\r\n  height: 150px; */\r\n}\r\n\r\n\r\n.rcorners2 {\r\n  /* border-radius: 10px;\r\n  border: 0.3px solid #b4baac; */\r\n  /* padding: 20px;\r\n  width: 200px;\r\n  height: 150px; */\r\n}\r\n\r\n.inner_part.textAreaminhgt textarea {\r\n  min-height: 105px;\r\n}\r\n\r\n\r\n/* calender */\r\n.react-date-picker {\r\n  display: inline-flex;\r\n  position: relative;\r\n}\r\n\r\n.react-date-picker,\r\n.react-date-picker *,\r\n.react-date-picker *:before,\r\n.react-date-picker *:after {\r\n  -moz-box-sizing: border-box;\r\n  -webkit-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.react-date-picker--disabled {\r\n  background-color: #f0f0f0;\r\n  color: #6d6d6d;\r\n}\r\n\r\n.react-date-picker__wrapper {\r\n  display: flex;\r\n  flex-grow: 1;\r\n  flex-shrink: 0;\r\n  border: thin solid gray;\r\n}\r\n\r\n.react-date-picker__inputGroup {\r\n  min-width: calc((4px 3) + 0.54em 8 + 0.217em * 2);\r\n  flex-grow: 1;\r\n  padding: 0 2px;\r\n  box-sizing: content-box;\r\n}\r\n\r\n.react-date-picker__inputGroup__divider {\r\n  padding: 1px 0;\r\n  white-space: pre;\r\n}\r\n\r\n.react-date-picker__inputGroup__divider,\r\n.react-date-picker__inputGroup__leadingZero {\r\n  display: inline-block;\r\n  font: inherit;\r\n}\r\n\r\n.react-date-picker__inputGroup__input {\r\n  min-width: 0.54em;\r\n  height: 100%;\r\n  position: relative;\r\n  padding: 0 1px;\r\n  border: 0;\r\n  background: none;\r\n  color: currentColor;\r\n  font: inherit;\r\n  box-sizing: content-box;\r\n  -webkit-appearance: textfield;\r\n  -moz-appearance: textfield;\r\n  appearance: textfield;\r\n}\r\n\r\n.react-date-picker__inputGroup__input::-webkit-outer-spin-button,\r\n.react-date-picker__inputGroup__input::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n.react-date-picker__inputGroup__input:invalid {\r\n  background: rgba(255, 0, 0, 0.1);\r\n}\r\n\r\n.react-date-picker__inputGroup__input--hasLeadingZero {\r\n  margin-left: -0.54em;\r\n  padding-left: calc(1px + 0.54em);\r\n}\r\n\r\n.react-date-picker__button {\r\n  border: 0;\r\n  background: transparent;\r\n  padding: 4px 6px;\r\n}\r\n\r\n.react-date-picker__button:enabled {\r\n  cursor: pointer;\r\n}\r\n\r\n.react-date-picker__button:enabled:hover .react-date-picker__button__icon,\r\n.react-date-picker__button:enabled:focus .react-date-picker__button__icon {\r\n  stroke: #0078d7;\r\n}\r\n\r\n.react-date-picker__button:disabled .react-date-picker__button__icon {\r\n  stroke: #6d6d6d;\r\n}\r\n\r\n.react-date-picker__button svg {\r\n  display: inherit;\r\n}\r\n\r\n.react-date-picker__calendar {\r\n  width: 350px;\r\n  max-width: 100vw;\r\n  z-index: 1;\r\n}\r\n\r\n.react-date-picker__calendar--closed {\r\n  display: none;\r\n}\r\n\r\n.react-date-picker__calendar .react-calendar {\r\n  border-width: thin;\r\n}\r\n\r\n.autoText {\r\n  padding: 0.5em;\r\n  /* background-color:pink; */\r\n  /* padding: 10px; */\r\n  width: 97%;\r\n  font-family: 'Lato', sans-serif;\r\n\r\n  border: 1px solid #bbbbbb;\r\n  border-radius: 4px;\r\n  margin-bottom: 10px;\r\n\r\n}\r\n\r\n.container_box .footer_box h4 {\r\n  padding-top: 0px;\r\n  padding-bottom: 10px;\r\n  text-align: left;\r\n}\r\n\r\n.footer_box .notify p {\r\n  text-align: left;\r\n  font-family: 'Lato', sans-serif !important;\r\n  line-height: 1.6;\r\n  color: #2b4e99;\r\n  padding: 6px 0;\r\n  font-size: 1em;\r\n}\r\n\r\n/* .footer_box .notify p strong{\r\n  color: rgb(43, 78, 153);\r\n  font-weight: 600;\r\n} */\r\n.display_inblock {\r\n  display: inline-block !important;\r\n}\r\n\r\n.casesedtl .inner_part {\r\n  width: 100%;\r\n}\r\n\r\n.casesedtl .form_styl {\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* commentbox */\r\n\r\n.Commentbox input {\r\n  width: 97%;\r\n  border: 1px solid #dadada;\r\n  border-radius: 5px;\r\n  padding: 10px 10px;\r\n  outline: none;\r\n}\r\n\r\n.Commentbox ul {\r\n  margin: 0px 0 10px;\r\n  padding-left: 0;\r\n}\r\n\r\n.Commentbox ul li {\r\n  list-style: none;\r\n  font-size: 14px;\r\n}\r\n\r\n.Commentbox ul li i {\r\n  margin-right: 5px;\r\n}\r\n\r\n.userProicon {\r\n  width: 30px;\r\n  height: 30px;\r\n  margin-right: 10px;\r\n}\r\n\r\n.userProicon img {\r\n  border-radius: 50%;\r\n  width: 100%;\r\n}\r\n\r\n.userCommentinput {\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n}\r\n\r\n.userCommentinput label {\r\n  width: calc(100% - 40px);\r\n}\r\n/* .raisequerydesc {\r\n  padding-bottom: 10px;\r\n  border-bottom: 1px solid #bbb;\r\n} */\r\n.casesedtl button#rs-\\:r0\\:-btn {\r\n  border-bottom: 1px solid #bbb;\r\n  border-radius: 0;\r\n}\r\n.form_sec .form_styl .inner_part p.note_pg{\r\n  color: #000 !important;\r\n}\r\n.align_end{\r\nalign-items: flex-end;\r\n}\r\n.flex-wrap{\r\n  flex-wrap: wrap;\r\n}\r\n.justify_center{\r\n  justify-content: center;\r\n}\r\n.in_notes p{\r\n  margin-bottom: -3px;\r\n}\r\n.Addchat_image img{\r\n  width: 200px !important;\r\n  height: 200px;\r\n  border-radius: 5px;\r\n  background: none;\r\n  padding: 0;\r\n  margin: 20px 10px 20px 0px;\r\n  /* margin-right: 15px; */\r\n  border: 1px solid red;\r\n}\r\n.form_sec .form_styl p a:hover{\r\n  text-decoration: underline;\r\n  color: #2f2fff !important;\r\n}\r\n.redirectnotes h5.pb1 {\r\n  font-size: 16px;\r\n}\r\n.cat_pg_text{\r\n  margin-bottom: 0;\r\n}\r\n.blc_txt p i:hover{\r\n  color: #000 !important;\r\n}\r\n.form_styl table tr td i:hover{\r\n  color: #000 !important;\r\n}\r\n.bottom_clr .blc_txt {\r\n  margin-bottom: 0px;\r\n}\r\n.container_body .form_styl .bottom_clr .blc_txt p:first-child{\r\n  padding-top: 0;\r\n}\r\na.linkcheckegi {\r\n  color: #294799;\r\n  font-weight: 700;\r\n}\r\n.communicationadd{\r\n  padding-top: 19px;\r\n}\r\n.min_hgt_100{\r\n  min-height: 100vh !important;\r\n}\r\n\r\nform .form_sec .form_styl .inner_part.notes_class {display: block;line-height: 16px;}\r\n\r\n.inner_part.notes_class span {\r\n    display: inline;\r\n    line-height: 1.5;\r\n}\r\n\r\n.notes_class p {\r\n  display: contents !important;\r\n}\r\n\r\n.container_body .form_sec .notes_class p {\r\n  display: contents !important;\r\n  font-size: 13px !important;\r\n  color: #294799 !important;\r\n}\r\n\r\n.container_body .form_sec .notes_class.preview_note {\r\n  font-size: 13px !important;\r\n  color: #294799 !important;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
